import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LocalEnum } from "@ss-activities/shared/services/auth-activity.service";

import { Observable, throwError } from "rxjs";
import {
  ActivityViewByType,
  DataProviderSourceSystem,
  FromTab,
  SourceObjectTypeId,
  StemeXeListType,
} from "../enums";

import { SimplestrataAuthService } from "src/app/shared/services/simplestrata-auth.service";
import { AuthService, AuthType } from "src/app/shared/services/auth.service";
import { ActivatedRoute } from "@angular/router";
import { StemexeDataProviderService } from "src/app/data-providers/services/stemexe-data-provider.service";
import { IActivityTag } from "../../shared/models/tags";
import { catchError, map } from "rxjs/operators";
import { TextSortPipe } from "../../shared/pipes/text-sort-activity.pipe";
import { ICreate } from "../models/additional-field";
import moment from "moment";
import { PredictedActivityPayload } from "../models/predicted-activity";

@Injectable({
  providedIn: "root",
})
export class ActivitiesService {
  arabicAlertMessage: string = "تمت العملية بنجاح";
  arabicAlertErrorMessage: string = "حدث خطأ";

  SourceSystemId: any = null;
  SourceTenantId: any = null;
  SourceObjectTypeId: any = null;
  SourceObjectId: any = null;
  TeamId: any = null;
  requirementId: any = null;
  riskId: string = '';
  sprintId: string = '';
  deliverableId: any = null;
  activityType: any = null;
  allDataProviders: Array<any> = [];
  selectedApps: Array<any> = [];
  externalSystems = [FromTab.ScoreCard, FromTab.Request, FromTab.Project, FromTab.Opportunity, FromTab.Higher, FromTab.Topic, FromTab.Details, FromTab.Members, FromTab.Listing, FromTab.Actions, FromTab.All];
  boardOwnerId: any = null;
  fromTab: any = null;
  forSprint: boolean = false;
  SourceObjectTypeIdForBug: number = 2;
  bugId: any = null;
  bugName: any = null;
  isArabic: boolean = false;

  boardId: any;
  keyPointId: any;

  constructor(
    private _http: HttpClient,
    private _authService: AuthService,
    private _simpleStrataAuthService: SimplestrataAuthService,
    private _StemexeDataProvider: StemexeDataProviderService,
    private route: ActivatedRoute
  ) {
    // this.route.queryParams.subscribe((params) => {
    //   console.log("ActivitiesParams", params);
    //   this.updateParams(params);
    // });
  }

  isJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }


  getDataForLanguage(jsonData: any, isArabic: boolean): string {
    let parsedData;
    try {
      parsedData = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
    } catch (error) {
      // If parsing fails, jsonData might not be valid JSON
      // Return the original jsonData
      return jsonData;
    }

    if (isArabic) {
      if (!parsedData?.ar || !parsedData?.ar.trim()) {
        if (parsedData?.en == undefined || parsedData?.en == null || parsedData?.en.length == 0) {
          return parsedData?.ar;
        }
        else {
          return parsedData?.en;
        }
      }
      else {
        if (parsedData?.ar == undefined || parsedData?.ar == null || parsedData?.ar.length == 0) {
          return parsedData?.en;
        }
        else {
          return parsedData?.ar;
        }

      }
    } else {
      if (parsedData?.en == undefined || parsedData?.en == null || parsedData?.en.length == 0) {
        return parsedData?.ar;
      }
      else {
        return parsedData?.en;
      }

    }
  }

  getResult(title): string {
    this.getLanguage();
    if (!!title && this.isJSON(title)) {
      title = JSON.parse(title);
      // title = !this.isArabic ? title.en : title.ar;
      title = !this.isArabic && title?.hasOwnProperty('en') ? title.en : this.isArabic && title?.hasOwnProperty('ar') ? title.ar : title;
    }
    return title;
  }

  getLanguage() {
    let lang = JSON.parse(localStorage.getItem("preferredLanguage"));
    if (lang) this.isArabic = lang.locale == 'ar' || false;
  }

  getDataProvider(): void {
    this.allDataProviders.length = 0;
    this.selectedApps.length = 0;
    this._StemexeDataProvider
      .getDataProviders("ActivitySource")
      .subscribe((data: any) => {
        console.log('@getDataProvider001', data);

        data.map((obj: any) => {
          if (obj.id == DataProviderSourceSystem.SimpleStrata.toString()) {
            this.allDataProviders.push(obj);
            this.selectedApps.push(DataProviderSourceSystem.SimpleStrata);
          }
          if (obj.id == DataProviderSourceSystem.EngPro.toString()) {
            this.allDataProviders.push(obj);
            this.selectedApps.push(DataProviderSourceSystem.EngPro);
          }
          if (obj.id == DataProviderSourceSystem.Esp.toString()) {
            this.allDataProviders.push(obj);
            this.selectedApps.push(DataProviderSourceSystem.Esp);
          }
          if (obj.id == DataProviderSourceSystem.OppPro.toString()) {
            this.allDataProviders.push(obj);
            this.selectedApps.push(DataProviderSourceSystem.OppPro);
          }
          if (obj.id == DataProviderSourceSystem.Plannexe.toString()) {
            this.allDataProviders.push(obj);
            this.selectedApps.push(DataProviderSourceSystem.Plannexe);
          }
          if (obj.id == DataProviderSourceSystem.Higher.toString()) {
            this.allDataProviders.push(obj);
            this.selectedApps.push(DataProviderSourceSystem.Higher);
          }
          if (obj.id == DataProviderSourceSystem.Technadopt.toString()) {
            this.allDataProviders.push(obj);
            this.selectedApps.push(DataProviderSourceSystem.Technadopt);
          }
        });
        this.allDataProviders.map((obj, index) => {
          if (obj.id == DataProviderSourceSystem.SimpleStrata.toString()) {
            let tempObj1 = this.allDataProviders[index];
            let tempObj2 = this.allDataProviders[0];
            this.allDataProviders[0] = obj;
            this.allDataProviders[index] = tempObj2;
          }
        });
      });
  }

  getSourceSystems(args?: any) {

    if (!args?.isFromESP || this.fromTab === FromTab.Request) {
      this.route.queryParams.subscribe((params) => {
        this.updateParams(params)
      });
    }

    let secIds: any = localStorage.getItem('secondaryIds');
    let orgId: any = localStorage.getItem('organziationId');
    let espOrgID = localStorage.getItem('espOrganziationId')
    let secIdsArr: any[] = secIds ? secIds.split(', ') : [];
    secIdsArr.push(orgId);
    let idObj = [];
    secIdsArr.forEach(id => {
      idObj.push({ systemId: 0, tenantId: +id })
    })
    if (this.selectedApps.includes(1)) {
      idObj.push({ systemId: 1, tenantId: 0 })
    }
    if (this.selectedApps.includes(2)) {
      idObj.push({ systemId: 2, tenantId: 0 })
    }
    if (this.selectedApps.includes(3)) {
      idObj.push({ systemId: 3, tenantId: 0 })
    }
    if (this.selectedApps.includes(4)) {
      idObj.push({ systemId: 4, tenantId: 0 })
    }
    if (this.selectedApps.includes(5)) {
      idObj.push({ systemId: 5, tenantId: 0 })
    }
    if (this.selectedApps.includes(6)) {
      idObj.push({ systemId: 6, tenantId: 0 })
    }
    if (this.selectedApps.includes(7)) {
      idObj.push({ systemId: 7, tenantId: 0 })
    }
    console.log('@fromTab', this.fromTab)
    if (this.fromTab) {
      switch (this.fromTab) {
        case FromTab.Request:
          idObj = [];
          idObj = [{
            systemId: DataProviderSourceSystem.Esp,
            tenantId: espOrgID ? +espOrgID : 0,
            objects: [{
              objectTypeId: this.SourceObjectTypeId || 1,
              objectId: this.SourceObjectId,
            }]
          }]
          break;
        case FromTab.ScoreCard:
          if (args?.teamId || args?.isReviewPeriod) {
            break;
          }
          idObj = [];
          const teamId = (this.TeamId) ? this.TeamId : (args?.teamId || 0);
          idObj = [{
            systemId: DataProviderSourceSystem.SimpleStrata, tenantId: parseInt(orgId),
            objects: [{
              objectTypeId: 1,
              objectId: teamId,
            }]
          }]
          break;
        case FromTab.Opportunity:
          idObj = [];
          idObj = [{
            systemId: DataProviderSourceSystem.OppPro, tenantId: this.SourceTenantId,
            objects: [{
              objectTypeId: 1,
              objectId: this.SourceObjectId !== null ? this.SourceObjectId : 0,
            }]
          }]
          break;
        case FromTab.Project:
          idObj = [];
          idObj = [{
            systemId: DataProviderSourceSystem.Plannexe, tenantId: this.SourceTenantId,
            objects: [{
              objectTypeId: this.SourceObjectTypeId || 1,
              objectId: this.SourceObjectId,
            }]
          }]
          break;
        case FromTab.Higher:
          idObj = [];
          idObj = [{
            systemId: DataProviderSourceSystem.Higher, tenantId: this.SourceTenantId,
            objects: [{
              objectTypeId: this.SourceObjectTypeId || 1,
              objectId: this.SourceObjectId,
            }]
          }]
          break;
        case FromTab.Topic:
          idObj = [];
          idObj = [{
            systemId: DataProviderSourceSystem.Technadopt, tenantId: 0,
            objects: [{
              objectTypeId: this.SourceObjectTypeId || 1,
              objectIdString: this.SourceObjectId,
            }]
          }]
          break;
        default:
      }
    }

    console.log('@fromTab2', idObj)

    return idObj;
  }

  getSourceSystemsForMemberDetail(args?: any) {

    let secIds: any = localStorage.getItem('secondaryIds');
    let orgId: any = localStorage.getItem('organziationId');
    let espOrgID = localStorage.getItem('espOrganziationId')
    let secIdsArr: any[] = secIds ? secIds.split(', ') : [];
    secIdsArr.push(orgId);
    let idObj = [];
    secIdsArr.forEach(id => {
      idObj.push({ systemId: 0, tenantId: +id })
    })
    if (this.selectedApps.includes(1)) {
      idObj.push({ systemId: 1, tenantId: 0 })
    }
    if (this.selectedApps.includes(2)) {
      idObj.push({ systemId: 2, tenantId: 0 })
    }
    if (this.selectedApps.includes(3)) {
      idObj.push({ systemId: 3, tenantId: 0 })
    }
    if (this.selectedApps.includes(4)) {
      idObj.push({ systemId: 4, tenantId: 0 })
    }
    if (this.selectedApps.includes(5)) {
      idObj.push({ systemId: 5, tenantId: 0 })
    }
    if (this.selectedApps.includes(6)) {
      idObj.push({ systemId: 6, tenantId: 0 })
    }
    if (this.selectedApps.includes(7)) {
      idObj.push({ systemId: 7, tenantId: 0 })
    }
    return idObj;
  }

  getData(): {
    SourceSystemId: any;
    SourceTenantId: any;
    SourceObjectTypeId: any;
    SourceObjectId: any;
  } {
    let data = {
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };
    return data;
  }

  getSourceSystemIds() {
    let ss = []
    if (this.activityType && this.selectedApps.length > 0) {
      ss = this.selectedApps;
    }
    if (this.fromTab) {
      ss = this.fromTab == FromTab.ScoreCard ? [0] : this.fromTab == FromTab.Project ? [5] : this.fromTab == FromTab.Request ? [1] : [];
    }
    return ss;
  }

  setSourceData(SourceSystemId, SourceTenantId, SourceObjectTypeId, SourceObjectId) {
    this.SourceSystemId = SourceSystemId;
    this.SourceTenantId = SourceTenantId;
    this.SourceObjectTypeId = SourceObjectTypeId;
    this.SourceObjectId = SourceObjectId;
  }

  getAllByWeeksForMine(PageNumber?:number): Observable<any> {
    this.getDataProvider();
    const url = `activities-svc/api/activities/mine/weeks`;
    let data = this.getData();
    data["pageNumber"] =  PageNumber ? PageNumber: 1;
    data["pageSize"] = 20;
    data["keyword"] = "";
    data["sources"] = this.getSourceSystems();

    if (this.externalSystems.includes(this.fromTab)) {
      data["includeUnlinkedActivities"] = false;
    } else {
      data["includeUnlinkedActivities"] = true;
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllInWeekForMine(engProLoggedInUserId?: string): Observable<any> {
    const url = `activities-svc/api/activities/mine/week`;
    return this._http.get<any>(url, this._authService.ssOptions);
  }

  getAllByWeeksForFollowing(
    userId: string
  ): Observable<any> {
    const url = `activities-svc/api/activities/all/weeks`;
    let data = {
      UserId: userId,
    };

    if (this.externalSystems.includes(this.fromTab)) {
      data["includeUnlinkedActivities"] = false;
    } else {
      data["includeUnlinkedActivities"] = true;
    }
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllInWeekForFollowing(): Observable<any> {
    const url = `activities-svc/api/activities/all/week`;
    return this._http.get<any>(url, this._authService.ssOptions);
  }

  getCountForClosed(
    keyword: string,
    groupType: number = 0,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
    oppProData?: any,
    isOppProEnabled?: boolean
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetClosedCountForFollowing`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      IsLagging?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      ownerUserIds?: number;
      IsSigned?: any;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    if (!!filter.GroupInfo) {
      data.GroupInfo = {
        StartDate: filter.GroupInfo.StartDate,
        EndDate: filter.GroupInfo.EndDate,
      };
    }

    let forFilter = false;
    let newFilter: any = {};
    if (!!filter.FromFilter) {
      forFilter = true;
      newFilter["PageIndex"] = pageIndex;
      newFilter["PageSize"] = pageSize;
      newFilter["GroupInfo"] = filter.GroupInfo;
      newFilter["GroupType"] = filter.GroupType;
      newFilter["IsSigned"] = filter.IsSigned;
      newFilter["StatusIds"] = filter.StatusIds;
      newFilter["ownerUserIds"] = filter.ownerUserIds;
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      } else {
        data.CreatorIds = [];
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.IsLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      } else {
        data.TeamIds = [];
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      } else {
        data.TacticIds = [];
      }

      if (!!filter.GroupType) {
        data.GroupType = filter.GroupType;
      }

      if (!!filter.ownerUserIds) {
        data.ownerUserIds = filter.ownerUserIds;
      }

      if (!!filter.IsSigned == null || filter.IsSigned || !filter.IsSigned) {
        data.IsSigned = filter.IsSigned;
      }
    }

    if (!!oppProData && isOppProEnabled) {
      data.OppProLogin = {
        TennantMapUrl: this._simpleStrataAuthService.oppProData.tennantMapUrl,
        CustomHeader: this._simpleStrataAuthService.oppProData.customHeader,
        AccessToken: oppProData.access_token,
      };
    }

    return this._http.post<any>(url, !forFilter ? data : newFilter, this._authService.ssOptions);
  }

  getCountForMine(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
    oppProData?: any,
    isOppProEnabled?: boolean
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetCountForMine`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      OwnerUserIds?: Array<any>;
      // OwnershipTypeIds?:Array<any>;
      FollowedByUserIds?: Array<any>;
      OpportunityIds?: Array<any>;
      CustomerIds?: Array<any>;
      SalesJobIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      IsLagging?: any;
      IsSigned?: any;
      IsFollowed?: any;
      IsManaged?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      IsHealthy?: any;
      OppProLogin?: any;
      GroupInfo?: any;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
      Tags?: Array<any>;
      TypeIds?: Array<any>;
      EndDate?: any;
      StartDate?: any;
      IncludeOnOrBeforeDueDate?: boolean;
      ActivitySortBy?: number;
      AssignedByUserIds?: Array<any>
    } = {
      // GroupType: groupType == 5 ? 0 : groupType,
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };

    if (!!groupInfo) {
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      } else {
        data.CreatorIds = [];
      }
      if (!!filter.AssignToIds) {
        data.OwnerUserIds = filter.AssignToIds;
      } else {
        data.OwnerUserIds = [];
      }
      if (!!filter.FollowedByIds) {
        data.FollowedByUserIds = filter.FollowedByIds;
      } else {
        data.FollowedByUserIds = [];
      }

      if (!!filter.OpportunityIds) {
        data.OpportunityIds = filter.OpportunityIds;
      }

      if (!!filter.CustomerIds) {
        data.CustomerIds = filter.CustomerIds;
      }

      if (!!filter.SalesJobIds) {
        data.SalesJobIds = filter.SalesJobIds;
      }

      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }

      if (filter.IncludeOnOrBeforeDueDate != null && filter.IncludeOnOrBeforeDueDate != undefined) {
        data.IncludeOnOrBeforeDueDate = filter.IncludeOnOrBeforeDueDate;
      }

      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      if (!!filter.StartDate) {
        data.StartDate = filter.StartDate;
      }
      if (!!filter.EndDate) {
        data.EndDate = filter.EndDate;
      }

      if (!!filter.ActivitySortBy) {
        data.ActivitySortBy = filter.ActivitySortBy;
      } else {
        data.ActivitySortBy = 0;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.IsLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      } else {
        data.TeamIds = [];
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      } else {
        data.TacticIds = [];
      }

      if (!!filter.TagIds) {
        data.Tags = filter.TagIds;
      } else {
        data.Tags = [];
      }

      if (this.forSprint) {
        data.IsFollowed = false;
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.TypeIds = filter.Type;
      } else {
        data.TypeIds = [];
      }

      data.IsManaged = filter.IsManaged;

      if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
        data.IsHealthy = filter.IsHealthy;
      else data.IsHealthy = null;


      if (!!filter.AssignedByUserIds) {
        data.AssignedByUserIds = filter.AssignedByUserIds;
      } else {
        data.AssignedByUserIds = [];
      }
      // if (!!filter.OwnershipTypeIds) {
      //   data.OwnershipTypeIds = filter.OwnershipTypeIds;
      // } else {
      //   data.OwnershipTypeIds = [];
      // }
    }

    if (!!oppProData && isOppProEnabled) {
      data.OppProLogin = {
        TennantMapUrl: this._simpleStrataAuthService.oppProData.tennantMapUrl,
        CustomHeader: this._simpleStrataAuthService.oppProData.customHeader,
        AccessToken: oppProData.access_token,
      };
    }

    data["IsMine"] = this.SourceSystemId || this.TeamId ? false : true;
    data["SourceSystemIds"] = this.getSourceSystemIds();
    data["SourceSystems"] = this.getSourceSystems();
    if (this.requirementId) {
      data["SourceObjectIdLevel2"] = parseInt(this.requirementId);
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllGroupsForMine(
    keyword: string,
    groupType: number,
    filter?: any,
    oppProData?: any,
    isOppProEnabled?: boolean
  ): Observable<any> {

    let data: {
      keyword: string;
      groupType: number;
      creatorIds?: Array<any>;
      endDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      viewMode: number
      pageNumber: number,
      pageSize: number
      includeUnlinkedActivities?: boolean,
    } = {
      groupType: groupType,
      viewMode: ActivityViewByType.Activity,
      keyword: keyword,
      pageNumber: 1,
      pageSize: 100000,
      startDate: null,
      endDate: null
    };


    if (this.externalSystems.includes(this.fromTab)) {
      var url = `activities-svc/api/activities/all/groups`;
      data.includeUnlinkedActivities = false;
    } else {
      var url = `activities-svc/api/activities/mine/groups`;
      data.includeUnlinkedActivities = true;
    }



    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.endDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.statusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;
    }

    if (this.externalSystems.includes(this.fromTab)) {
      data["includeUnlinkedActivities"] = false;
    }

    data.viewMode = filter.ViewBy;
    console.log('@groupByData', data)
    if (groupType == 6) {
      data.viewMode = ActivityViewByType.Efforts;
    }
    data["sources"] = this.getSourceSystems();

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllByGroupForMine(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
    dependencyActivityId?: number,
    userId?: number,
  ): Observable<any> {
    const data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      ownerIds?: Array<any>;
      // OwnershipTypeIds?:Array<any>;
      followerIds?: Array<any>;
      // OpportunityIds?: Array<any>;
      // CustomerIds?: Array<any>;
      // SalesJobIds?: Array<any>;
      endDate?: any;
      activityStartDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isHealthy?: any;
      isManaged?: any;
      userId?: any;
      GroupInfo?: any;
      viewMode?: number;

      tags?: Array<any>;
      typeIds?: Array<any>;
      sortBy?: number;
      managerIds?: Array<any>
      sources?: Array<any>;
      dependencyActivityId?: number;
      isOverdue?:boolean;
    } = {
      groupType: groupType,
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
      dependencyActivityId: dependencyActivityId,
    };

    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
      // Inject system-filter params for SimpleStrata / PlanneXe groups
      if (groupInfo.groupSystemId != null) {
        data["groupSystemId"] = groupInfo.groupSystemId;
      }
      if (groupInfo.groupObjectTypeId != null) {
        data["groupObjectTypeId"] = groupInfo.groupObjectTypeId;
      }
      // Override groupType when the group carries an explicit value (8 for system-filter groups)
      if (groupInfo.groupType != null) {
        data.groupType = groupInfo.groupType;
      }
      // Force startDate / endDate from the group's stored filter dates (bypasses query-param path)
      if (groupInfo.filterStartDate) {
        data.startDate = groupInfo.filterStartDate;
      }
      if (groupInfo.filterEndDate) {
        data.endDate = groupInfo.filterEndDate;
      }
    }

    console.log('@filterData', filter)
    this.getDataProvider();

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      } else {
        data.creatorIds = [];
      }
      if (!!filter.AssignedByUserIds) {
        data.managerIds = filter.AssignedByUserIds;
      } else {
        data.managerIds = [];
      }
      if (!!filter.AssignToIds) {
        data.ownerIds = filter.AssignToIds;
      } else {
        data.ownerIds = [];
      }
      if (!!filter.FollowedByIds) {
        data.followerIds = filter.FollowedByIds;
      } else {
        data.followerIds = [];
      }

      if (!!filter.DueDate) {
        data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
      }

      if (filter.IncludeOnOrBeforeDueDate != null && filter.IncludeOnOrBeforeDueDate != undefined && !!filter.DueDate) {
        if (!filter.IncludeOnOrBeforeDueDate) {
          data.startDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        } else {
          data.startDate = null;
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        }
      }

      if (!!filter.StatusIds) {
        data.statusIds = filter.StatusIds;
      }

      if (!!filter.StartDate) {
        data.startDate = moment(filter.StartDate).locale('en').format("YYYY-MM-DD");
      }

      if (!!filter.ActivityStartDate && filter.IncludeOnOrBeforeDueDate) {
        data.startDate = moment(filter.ActivityStartDate).locale('en').format("YYYY-MM-DD");
      }

      if (!!filter.ActivitySortBy) {
        data.sortBy = filter.ActivitySortBy;
      } else {
        data.sortBy = 0;
      }

      if (!!filter.EndDate) {
        data.endDate = moment(filter.EndDate).locale('en').format("YYYY-MM-DD");
      }

      if (this.forSprint) {
        data.isFollowed = false;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;
      data.isManaged = filter.IsManaged;

      if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
        data.isHealthy = filter.IsHealthy;
      else data.isHealthy = null;

      if (!!filter.TagIds) {
        data.tags = filter.TagIds;
      } else {
        data.tags = [];
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.typeIds = filter.Type;
      } else {
        data.typeIds = [];
      }

    }

    data.viewMode = filter?.ViewBy || ActivityViewByType.Activity;
    if (groupType == 6) {
      data.viewMode = ActivityViewByType.Efforts;
    } else if (groupType == 7) {
      data.viewMode = ActivityViewByType.Efforts;
    }
    // data["IsMine"] = this.SourceSystemId || this.TeamId ? false : true;
    // data["SourceSystemIds"] = this.getSourceSystemIds();
    data.sources = this.getSourceSystems();
    console.log('fromTab0', filter)
    if (userId) {
      data.userId = userId;
    }
    this.applyFilterForSources(filter, data)

    // if(this.fromTab == FromTab.Members || this.fromTab == FromTab.Listing || this.fromTab == FromTab.Actions || this.fromTab == FromTab.All){
    //   const filteredData = data["sources"].filter(item => item?.objects?.length !== 0);
    //   data.sources = filteredData;
    // }


    if (this.requirementId) {
      data["SourceObjectIdLevel2"] = parseInt(this.requirementId);
    }

    if (this.deliverableId) {
      data["SourceObjectIdLevel3"] = parseInt(this.deliverableId);
    }

    // Final override: ensure system-filter groups always use their stored dates
    if (groupInfo && groupInfo.filterStartDate) {
      data.startDate = groupInfo.filterStartDate;
    }
    if (groupInfo && groupInfo.filterEndDate) {
      data.endDate = groupInfo.filterEndDate;
    }

    if (this.externalSystems.includes(this.fromTab)) {
      var url = `activities-svc/api/activities/all`;
      if (data.dependencyActivityId || this.fromTab == FromTab.Members || this.fromTab == FromTab.Listing || this.fromTab == FromTab.Actions || this.fromTab == FromTab.All) {
        data["includeUnlinkedActivities"] = true;
      }
      else {
        data["includeUnlinkedActivities"] = false;
      }
    } else {
      data["includeUnlinkedActivities"] = true;
      var url = `activities-svc/api/activities/mine`;
    }

    if(data.groupType == 8){
      data["includeUnlinkedActivities"] = false;
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllByGroupForAllLinkedActivites(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
    dependencyActivityId?: number,
    userId?: number,
  ): Observable<any> {
    const data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      ownerIds?: Array<any>;
      // OwnershipTypeIds?:Array<any>;
      followerIds?: Array<any>;
      // OpportunityIds?: Array<any>;
      // CustomerIds?: Array<any>;
      // SalesJobIds?: Array<any>;
      endDate?: any;
      activityStartDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isHealthy?: any;
      isManaged?: any;
      userId?: any;
      GroupInfo?: any;
      viewMode?: number;

      tags?: Array<any>;
      typeIds?: Array<any>;
      sortBy?: number;
      managerIds?: Array<any>
      sources?: Array<any>;
      dependencyActivityId?: number;
    } = {
      groupType: groupType,
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
      dependencyActivityId: dependencyActivityId,
    };

    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    console.log('@filterData', filter)
    this.getDataProvider();

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      } else {
        data.creatorIds = [];
      }
      if (!!filter.AssignedByUserIds) {
        data.managerIds = filter.AssignedByUserIds;
      } else {
        data.managerIds = [];
      }
      if (!!filter.AssignToIds) {
        data.ownerIds = filter.AssignToIds;
      } else {
        data.ownerIds = [];
      }
      if (!!filter.FollowedByIds) {
        data.followerIds = filter.FollowedByIds;
      } else {
        data.followerIds = [];
      }

      if (!!filter.DueDate) {
        data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
      }

      if (filter.IncludeOnOrBeforeDueDate != null && filter.IncludeOnOrBeforeDueDate != undefined && !!filter.DueDate) {
        if (!filter.IncludeOnOrBeforeDueDate) {
          data.startDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        } else {
          data.startDate = null;
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        }
      }

      if (!!filter.StatusIds) {
        data.statusIds = filter.StatusIds;
      }

      if (!!filter.StartDate) {
        data.startDate = moment(filter.StartDate).locale('en').format("YYYY-MM-DD");
      }

      if (!!filter.ActivityStartDate && filter.IncludeOnOrBeforeDueDate) {
        data.startDate = moment(filter.ActivityStartDate).locale('en').format("YYYY-MM-DD");
      }

      if (!!filter.ActivitySortBy) {
        data.sortBy = filter.ActivitySortBy;
      } else {
        data.sortBy = 0;
      }

      if (!!filter.EndDate) {
        data.endDate = moment(filter.EndDate).locale('en').format("YYYY-MM-DD");
      }

      if (this.forSprint) {
        data.isFollowed = false;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;
      data.isManaged = filter.IsManaged;

      if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
        data.isHealthy = filter.IsHealthy;
      else data.isHealthy = null;

      if (!!filter.TagIds) {
        data.tags = filter.TagIds;
      } else {
        data.tags = [];
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.typeIds = filter.Type;
      } else {
        data.typeIds = [];
      }

    }

    data.viewMode = filter?.ViewBy || ActivityViewByType.Activity;
    if (groupType == 6) {
      data.viewMode = ActivityViewByType.Efforts;
    }
    // data["IsMine"] = this.SourceSystemId || this.TeamId ? false : true;
    // data["SourceSystemIds"] = this.getSourceSystemIds();
    data.sources = this.getSourceSystems();
    console.log('fromTab0', filter)
    if (userId) {
      data.userId = userId;
    }
    this.applyFilterForSources(filter, data)


    var url = `activities-svc/api/activities/all`;
    data["includeUnlinkedActivities"] = true;


    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllByAssigned(
    keyword: string,
    pageSize: number,
    pageIndex: number
  ): Observable<any> {
    const url = `activities-svc/api/activities/assigned`;
    let data: {
      keyword: any;
      pageNumber: any;
      pageSize: any;
      sources: any;
    } = {
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
      sources: []
    }

    this.getDataProvider();

    data["sources"] = this.getSourceSystems();

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllClosed(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetAllClosedForFollowing`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      isLagging?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      ownerUserIds?: number;
      IsSigned?: any;
    } = {
      GroupType: groupType == 5 ? 0 : groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    if (!!filter.GroupInfo) {
      data.GroupInfo = {
        StartDate: filter.GroupInfo.StartDate,
        EndDate: filter.GroupInfo.EndDate,
      };
    }
    let forFilter = false;
    let newFilter: any = {};
    if (!!filter.FromFilter) {
      forFilter = true;
      newFilter["PageIndex"] = pageIndex;
      newFilter["PageSize"] = pageSize;
      newFilter["GroupInfo"] = filter.GroupInfo;
      newFilter["GroupType"] = filter.groupType == 5 ? 0 : filter.groupType;
      newFilter["IsSigned"] = filter.IsSigned;
      newFilter["StatusIds"] = filter.StatusIds;
      newFilter["ownerUserIds"] = filter.ownerUserIds;
    }
    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      } else {
        data.CreatorIds = [];
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      } else {
        data.TeamIds = [];
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      } else {
        data.TacticIds = [];
      }

      if (!!filter.GroupType) {
        data.GroupType = filter.groupType == 5 ? 0 : filter.groupType;
      }

      if (!!filter.ownerUserIds) {
        data.ownerUserIds = filter.ownerUserIds;
      }

      if (!!filter.IsSigned == null || filter.IsSigned || !filter.IsSigned) {
        data.IsSigned = filter.IsSigned;
      }
    }

    return this._http.post<any>(url, !forFilter ? data : newFilter, this._authService.ssOptions);
  }

  getCountForFollowing(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetCountForFollowing`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      IsLagging?: any;
      IsSigned?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };

    if (!!groupInfo) {
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.IsLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;
      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      }
      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      }
    }
    data["SourceSystemIds"] = this.getSourceSystemIds();
    data["SourceSystems"] = this.getSourceSystems();

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllGroupsForFollowing(
    keyword: string,
    groupType: number,
    filter?: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/following/groups`;
    let data: {
      keyword: string;
      groupType: number;
      creatorIds?: Array<any>;
      endDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      // TeamIds?: Array<any>;
      // TacticIds?: Array<any>;
      // SourceSystemId: any;
      // SourceTenantId: any;
      // SourceObjectTypeId: any;
      // SourceObjectId: any;
    } = {
      groupType: groupType,
      keyword: keyword,
      // SourceSystemId: this.SourceSystemId,
      // SourceTenantId: this.SourceTenantId,
      // SourceObjectTypeId: this.SourceObjectTypeId,
      // SourceObjectId: this.SourceObjectId,
    };

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.endDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.statusIds = [];
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;
      data["sources"] = this.getSourceSystems();
      // if (!!filter.TeamIds) {
      //   data.TeamIds = filter.TeamIds;
      // }

      // if (!!filter.TacticIds) {
      //   data.TacticIds = filter.TacticIds;
      // }
    }
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllFollowingActivities(
    keyword: string,
    groupType: number,
    filter?: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/following`;
    let data: {
      keyword: string;
      groupType: number;
      creatorIds?: Array<any>;
      endDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      // TeamIds?: Array<any>;
      // TacticIds?: Array<any>;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
    } = {
      groupType: groupType,
      keyword: keyword,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.endDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.statusIds = [];
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;

      // if (!!filter.TeamIds) {
      //   data.TeamIds = filter.TeamIds;
      // }

      // if (!!filter.TacticIds) {
      //   data.TacticIds = filter.TacticIds;
      // }
    }
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getSharedActivities(): Observable<any> {
    const url = `activities-svc/api/activities/shared/stats`;
    let data: {
      sources: any;
    } = {
      sources: this.getSourceSystems()
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllByGroupForFollowing(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/following`;
    let data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      endDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      // TeamIds?: Array<any>;
      // TacticIds?: Array<any>;
      // OppProLogin?: any;
      GroupInfo?: any;
      groupKey?: any;
      // SourceSystemId: any;
      // SourceTenantId: any;
      // SourceObjectTypeId: any;
      // SourceObjectId: any;
      Tags?: Array<any>;
      TypeIds?: Array<any>;
    } = {
      groupType: groupType,
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
      // SourceSystemId: this.SourceSystemId,
      // SourceTenantId: this.SourceTenantId,
      // SourceObjectTypeId: this.SourceObjectTypeId,
      // SourceObjectId: this.SourceObjectId,
    };

    if (!!groupInfo) {
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    data.groupKey = groupInfo.groupId
    data["sources"] = this.getSourceSystems();

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.endDate = filter.DueDate;
      }
      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;

      // if (!!filter.TeamIds) {
      //   data.TeamIds = filter.TeamIds;
      // }

      // if (!!filter.TacticIds) {
      //   data.TacticIds = filter.TacticIds;
      // }
      if (!!filter.TagIds) {
        data.Tags = filter.TagIds;
      } else {
        data.Tags = [];
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.TypeIds = filter.Type;
      } else {
        data.TypeIds = [];
      }
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getCountForShared(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetCountForShared`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      IsLagging?: any;
      IsSigned?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };

    if (!!groupInfo) {
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.IsLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      }
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllShared(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {
    const url = `activities-svc/api/activities/shared`;
    let data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      endDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      // TeamIds?: Array<any>;
      // TacticIds?: Array<any>;
      // OppProLogin?: any;
      groupInfo?: any;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
      tags?: Array<any>;
      typeIds?: Array<any>;
    } = {
      groupType: groupType,
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };

    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.groupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.endDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.statusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;

      // if (!!filter.TeamIds) {
      //   data.teamIds = filter.TeamIds;
      // }

      // if (!!filter.TacticIds) {
      //   data.TacticIds = filter.TacticIds;
      // }

      if (!!filter.TagIds) {
        data.tags = filter.TagIds;
      } else {
        data.tags = [];
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.typeIds = filter.Type;
      } else {
        data.typeIds = [];
      }
    }

    data["sources"] = this.getSourceSystems();

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getCountForBacklog(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetCountForBacklog`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      isLagging?: any;
      IsSigned?: any;
      IsFollowed?: any;
      IsHealthy?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
      TypeIds?: Array<any>;
      OpportunityIds?: Array<any>;
      CustomerIds?: Array<any>;
      SalesJobIds?: Array<any>;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };

    if (!!groupInfo) {
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    if (!!filter) {
      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      }
      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      }
      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      if (!!filter.Type && filter.Type.length == 1) {
        data.TypeIds = filter.Type;
      } else {
        data.TypeIds = [];
      }

      if (!!filter.OpportunityIds) {
        data.OpportunityIds = filter.OpportunityIds;
      }

      if (!!filter.CustomerIds) {
        data.CustomerIds = filter.CustomerIds;
      }

      if (!!filter.SalesJobIds) {
        data.SalesJobIds = filter.SalesJobIds;
      }

      if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
        data.IsHealthy = filter.IsHealthy;
      else data.IsHealthy = null;

    }
    data["SourceSystemIds"] = this.getSourceSystemIds();
    data["SourceSystems"] = this.getSourceSystems();
    if (this.requirementId) {
      data["SourceObjectIdLevel2"] = parseInt(this.requirementId);
    }
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllByGroupForBacklog(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {

    let data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      endDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isManaged?: any;
      isHealthy?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
      tags?: Array<any>;
      typeIds?: Array<any>;
      OpportunityIds?: Array<any>;
      CustomerIds?: Array<any>;
      SalesJobIds?: Array<any>;
      sources?: Array<any>;
    } = {
      groupType: groupType,
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };
    this.getDataProvider();
    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    if (!!filter) {
      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";

      if (!!filter.TagIds) {
        data.tags = filter.TagIds;
      } else {
        data.tags = [];
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.typeIds = filter.Type;
      } else {
        data.typeIds = [];
      }

      if (!!filter.OpportunityIds) {
        data.OpportunityIds = filter.OpportunityIds;
      }

      if (!!filter.CustomerIds) {
        data.CustomerIds = filter.CustomerIds;
      }

      if (!!filter.SalesJobIds) {
        data.SalesJobIds = filter.SalesJobIds;
      }

      if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
        data.isHealthy = filter.IsHealthy;
      else data.isHealthy = null;


      data.isFollowed = filter.IsFollowed;
      data.isManaged = filter.IsManaged;
    }

    data.sources = this.getSourceSystems();
    data["SourceSystemIds"] = this.getSourceSystemIds();
    if (this.requirementId) {
      data["SourceObjectIdLevel2"] = parseInt(this.requirementId);
    }

    this.applyFilterForSources(filter, data);

    if (this.externalSystems.includes(this.fromTab)) {
      var url = `activities-svc/api/activities/all/backlog`;
      data["includeUnlinkedActivities"] = false;
    } else {
      data["includeUnlinkedActivities"] = true;
      var url = `activities-svc/api/activities/backlog`;
    }


    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllGroupsForBacklog(
    keyword: string,
    groupType: number,
    filter?: any,
  ): Observable<any> {
    const url = `activities-svc/api/activities/backlog/groups`;
    let data: {
      keyword: string;
      groupType: number;
      creatorIds?: Array<any>;
      endDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
    } = {
      groupType: groupType,
      keyword: keyword,
    };

    if (!!filter) {
      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getStatsForESPRequest(requestId: any, fromTab: any = null, sources?: any, startDate?: string, endDate?: string): Observable<any> {
    if (fromTab !== null) {
      this.fromTab = fromTab;
    }
    this.getDataProvider();
    const url = `activities-svc/api/activities/all/stats`;
    let data = {};
    if (sources.length) {
      data["sources"] = sources;
    }
    else {
      data["sources"] = this.getSourceSystems({ isFromESP: true });
    }

    data["startDate"] = startDate ? moment(startDate).locale('en').format("YYYY-MM-DD") : null;
    data["endDate"] = endDate ? moment(endDate).locale('en').format("YYYY-MM-DD") : null;


    if (this.externalSystems.includes(this.fromTab)) {
      data["includeUnlinkedActivities"] = false;
    } else {
      data["includeUnlinkedActivities"] = true;
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  UpdateDueDate(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/duedate`;
    // data["SourceSystemId"] = this.SourceSystemId;
    // data["SourceTenantId"] = this.SourceTenantId;
    // data["SourceObjectTypeId"] = this.SourceObjectTypeId;
    // data["SourceObjectId"] = this.SourceObjectId;

    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  getCountForUser(
    id: string,
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetCountForUser`;
    let data: {
      UserId: String;
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      // OwnershipTypeIds?: Array<any>;
      IsImportant?: any;
      isLagging?: any;
      IsSigned?: any;
      IsFollowed?: any;
      IsManaged?: any;
      IsHealthy?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      SourceSystemId: any;
      SourceTenantId: any;
      SourceObjectTypeId: any;
      SourceObjectId: any;
      OpportunityIds?: Array<any>;
      CustomerIds?: Array<any>;
      SalesJobIds?: Array<any>;
      AssignorStatusIds?: Array<any>;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      UserId: id,
      PageIndex: pageIndex,
      PageSize: pageSize,
      SourceSystemId: this.SourceSystemId,
      SourceTenantId: this.SourceTenantId,
      SourceObjectTypeId: this.SourceObjectTypeId,
      SourceObjectId: this.SourceObjectId,
    };

    if (!!groupInfo) {
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }
      // if (!!filter.OwnershipTypeIds) {
      //   data.OwnershipTypeIds = filter.OwnershipTypeIds;
      // }

      if (!!filter.AssignorStatusIds) {
        data.AssignorStatusIds = filter.AssignorStatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";

      data.IsFollowed = filter.IsFollowed;
      data.IsManaged = filter.IsManaged;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      }

      if (!!filter.OpportunityIds) {
        data.OpportunityIds = filter.OpportunityIds;
      }

      if (!!filter.CustomerIds) {
        data.CustomerIds = filter.CustomerIds;
      }

      if (!!filter.SalesJobIds) {
        data.SalesJobIds = filter.SalesJobIds;
      }

      if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
        data.IsHealthy = filter.IsHealthy;
      else data.IsHealthy = null;

    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllByGroupForUser(
    id: string,
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {
    const url = `activities-svc/api/activities/user`;
    let data: {
      userId: String;
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      endDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      // OwnershipTypeIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isManaged?: any;
      isHealthy?: any;
      // TeamIds?: Array<any>;
      // TacticIds?: Array<any>;
      // OppProLogin?: any;
      GroupInfo?: any;
      sources: any;
      tags?: Array<any>;
      typeIds?: Array<any>;
      // OpportunityIds?: Array<any>;
      // CustomerIds?: Array<any>;
      // SalesJobIds?: Array<any>;
      assignorStatusIds?: Array<any>;
    } = {
      groupType: groupType,
      keyword: keyword,
      userId: id,
      pageNumber: pageIndex,
      pageSize: pageSize,
      sources: this.getSourceSystems()
    };


    if (this.externalSystems.includes(this.fromTab)) {
      data["includeUnlinkedActivities"] = false;
    }
    else {
      data["includeUnlinkedActivities"] = true;
    }

    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
      if (groupInfo.groupSystemId != null) {
        data["groupSystemId"] = groupInfo.groupSystemId;
      }
      if (groupInfo.groupObjectTypeId != null) {
        data["groupObjectTypeId"] = groupInfo.groupObjectTypeId;
      }
      if (groupInfo.groupType != null) {
        data.groupType = groupInfo.groupType;
      }
      if (groupInfo.filterStartDate) {
        data.startDate = groupInfo.filterStartDate;
      }
      if (groupInfo.filterEndDate) {
        data.endDate = groupInfo.filterEndDate;
      }
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
      }

      if (!!filter.ActivityStartDate) {
        data.startDate = moment(filter.ActivityStartDate).locale('en').format('YYYY-MM-DD');
      }

      if (!!filter.StatusIds) {
        data.statusIds = filter.StatusIds;
      }
      // if (!!filter.OwnershipTypeIds) {
      //   data.OwnershipTypeIds = filter.OwnershipTypeIds;
      // }

      if (!!filter.AssignorStatusIds) {
        data.assignorStatusIds = filter.AssignorStatusIds;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";

      data.isFollowed = filter.IsFollowed;
      data.isManaged = filter.IsManaged;

      // if (!!filter.TeamIds) {
      //   data.TeamIds = filter.TeamIds;
      // }

      // if (!!filter.TacticIds) {
      //   data.TacticIds = filter.TacticIds;
      // }
      if (!!filter.TagIds) {
        data.tags = filter.TagIds;
      } else {
        data.tags = [];
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.typeIds = filter.Type;
      } else {
        data.typeIds = [];
      }


      this.applyFilterForSources(filter, data);
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }


  applyFilterForSources(filter: any, data: any) {

    console.log('@applyFilterForSources', filter)
    console.log('@applyFilterForSources2', data)
    if ((filter?.TeamIds && Array.isArray(filter?.TeamIds)) || (filter?.TacticIds && Array.isArray(filter?.TacticIds))) {
      for (let a = 0; a < data.sources?.length; a++) {
        if (data.sources[a].systemId == DataProviderSourceSystem.SimpleStrata) {
          if (!data.sources[a].objects) {
            data.sources[a].objects = [];
          }
          if (filter.TeamIds && Array.isArray(filter.TeamIds)) {
            for (let b = 0; b < filter.TeamIds.length; b++) {
              data.sources[a].objects.push({
                objectTypeId: 1,
                objectId: filter.TeamIds[b]
              });
            }
          }
          if (filter.TacticIds && Array.isArray(filter.TacticIds)) {
            for (let c = 0; c < filter.TacticIds.length; c++) {
              data.sources[a].objects.push({
                objectTypeId: 2,
                objectId: filter.TacticIds[c]
              });
            }
          }
        }
      }
    }

    if ((filter?.OpportunityIds && Array.isArray(filter?.OpportunityIds)) || (filter?.CustomerIds && Array.isArray(filter?.CustomerIds)) || (filter?.SalesJobIds && Array.isArray(filter?.SalesJobIds))) {
      for (let a = 0; a < data.sources?.length; a++) {
        if (data.sources[a].systemId == DataProviderSourceSystem.OppPro) {
          if (!data.sources[a].objects) {
            data.sources[a].objects = [];
          }
          if (filter.OpportunityIds && Array.isArray(filter.OpportunityIds)) {
            for (let b = 0; b < filter.OpportunityIds.length; b++) {
              data.sources[a].objects.push({
                objectTypeId: 1,
                objectId: filter.OpportunityIds[b]
              });
            }
          }
          if (filter.CustomerIds && Array.isArray(filter.CustomerIds)) {
            for (let c = 0; c < filter.CustomerIds.length; c++) {
              data.sources[a].objects.push({
                objectTypeId: 2,
                objectId: filter.CustomerIds[c]
              });
            }
          }
          if (filter.SalesJobIds && Array.isArray(filter.SalesJobIds)) {
            for (let d = 0; d < filter.SalesJobIds.length; d++) {
              data.sources[a].objects.push({
                objectTypeId: 3,
                objectId: filter.SalesJobIds[d]
              });
            }
          }
        }
      }
    }

    if ((filter?.PlannexeProjectIds && Array.isArray(filter?.PlannexeProjectIds)) || (filter?.RequirementIds && Array.isArray(filter?.RequirementIds)) || (filter?.DeliverableIds && Array.isArray(filter?.DeliverableIds))) {
      for (let a = 0; a < data.sources?.length; a++) {
        if (data.sources[a].systemId == DataProviderSourceSystem.Plannexe) {
          if (!data.sources[a].objects) {
            data.sources[a].objects = [];
          }
          if (filter.PlannexeProjectIds && Array.isArray(filter.PlannexeProjectIds)) {
            for (let b = 0; b < filter.PlannexeProjectIds.length; b++) {
              data.sources[a].objects.push({
                objectTypeId: 1,
                objectId: filter.PlannexeProjectIds[b]
              });
            }
          }
          if (filter.RequirementIds && Array.isArray(filter.RequirementIds)) {
            for (let c = 0; c < filter.RequirementIds.length; c++) {
              data.sources[a].objects.push({
                objectTypeId: 2,
                objectId: filter.RequirementIds[c]
              });
            }
          }
          if (filter.DeliverableIds && Array.isArray(filter.DeliverableIds)) {
            for (let d = 0; d < filter.DeliverableIds.length; d++) {
              data.sources[a].objects.push({
                objectTypeId: 3,
                objectId: filter.DeliverableIds[d]
              });
            }
          }
        }
      }
    }

    if ((filter?.TopicIds && Array.isArray(filter?.TopicIds))) {
      for (let a = 0; a < data.sources?.length; a++) {
        if (data.sources[a].systemId == DataProviderSourceSystem.Technadopt) {
          if (!data.sources[a].objects) {
            data.sources[a].objects = [];
          }
          if (filter.TopicIds && Array.isArray(filter.TopicIds)) {
            for (let b = 0; b < filter.TopicIds.length; b++) {
              data.sources[a].objects.push({
                objectTypeId: 1,
                objectIdString: filter.TopicIds[b]
              });
            }
          }
        }
      }
    }

    if ((filter?.HigherProjectIds && Array.isArray(filter?.HigherProjectIds)) || (filter?.VacancyIds && Array.isArray(filter?.VacancyIds)) || (filter?.CandidateIds && Array.isArray(filter?.CandidateIds))) {
      for (let a = 0; a < data.sources?.length; a++) {
        if (data.sources[a].systemId == DataProviderSourceSystem.Higher) {
          if (!data.sources[a].objects) {
            data.sources[a].objects = [];
          }
          if (filter.HigherProjectIds && Array.isArray(filter.HigherProjectIds)) {
            for (let b = 0; b < filter.HigherProjectIds.length; b++) {
              data.sources[a].objects.push({
                objectTypeId: 1,
                objectId: filter.HigherProjectIds[b]
              });
            }
          }
          if (filter.VacancyIds && Array.isArray(filter.VacancyIds)) {
            for (let c = 0; c < filter.VacancyIds.length; c++) {
              data.sources[a].objects.push({
                objectTypeId: 2,
                objectId: filter.VacancyIds[c]
              });
            }
          }
          if (filter.CandidateIds && Array.isArray(filter.CandidateIds)) {
            for (let c = 0; c < filter.CandidateIds.length; c++) {
              data.sources[a].objects.push({
                objectTypeId: 3,
                objectId: filter.CandidateIds[c]
              });
            }
          }
        }
      }
    }

    if ((filter?.DefinitionIds && Array.isArray(filter?.DefinitionIds)) || (filter?.RequestIds && Array.isArray(filter?.RequestIds))) {
      for (let a = 0; a < data.sources?.length; a++) {
        if (data.sources[a].systemId == DataProviderSourceSystem.Esp) {
          if (!data.sources[a].objects) {
            data.sources[a].objects = [];
          }
          if (filter.DefinitionIds && Array.isArray(filter.DefinitionIds)) {
            for (let c = 0; c < filter.DefinitionIds.length; c++) {
              data.sources[a].objects.push({
                objectTypeId: 1,
                objectId: filter.DefinitionIds[c]
              });
            }
          }
          if (filter.RequestIds && Array.isArray(filter.RequestIds)) {
            for (let d = 0; d < filter.RequestIds.length; d++) {
              data.sources[a].objects.push({
                objectTypeId: 2,
                objectId: filter.RequestIds[d]
              });
            }
          }
        }
      }
    }

    if (typeof filter?.IsHealthy === 'boolean' && filter?.IsHealthy === false)
      data.isHealthy = filter.IsHealthy;
    else
      data.isHealthy = null;
  }

  getFollowingUserStats(
    id: number,
  ): Observable<any> {
    const url = `activities-svc/api/activities/user/stats`;
    let data: {
      userId: any;
      sources: any;
    } = {
      userId: id,
      sources: this.getSourceSystems()
    };

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllGroupsForUser(
    id: string,
    keyword: string,
    groupType: number,
    filter?: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/user/groups`;
    let data: {
      userId: String;
      keyword: string;
      groupType: number;
      creatorIds?: Array<any>;
      endDate?: any;
      statusIds?: Array<any>;
      // OwnershipTypeIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isManaged?: any;
      // TeamIds?: Array<any>;
      // TacticIds?: Array<any>;
    } = {
      groupType: groupType,
      keyword: keyword,
      userId: id,
    };

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.DueDate) {
        data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
      }
      if (!!filter.StatusIds) {
        data.statusIds = filter.StatusIds;
      }
      // if (!!filter.OwnershipTypeIds) {
      //   data.OwnershipTypeIds = filter.OwnershipTypeIds;
      // }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";

      data.isFollowed = filter.IsFollowed;
      data.isManaged = filter.IsManaged;

      // if (!!filter.TeamIds) {
      //   data.TeamIds = filter.TeamIds;
      // }

      // if (!!filter.TacticIds) {
      //   data.TacticIds = filter.TacticIds;
      // }
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllNewAssigned(
    keyword: string,
    pageIndex: number,
    pageSize: number
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetAllNewAssigned`;
    let data = {
      PageIndex: pageIndex,
      Keyword: keyword,
      PageSize: pageSize,
    };

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllNewReported(
    keyword: string,
    pageIndex: number,
    pageSize: number,
  ): Observable<any> {
    const url = `activities-svc/api/activities/reported`;
    let data = {
      pageNumber: pageIndex,
      keyword: keyword,
      pageSize: pageSize,
      sources: this.getSourceSystems(),
    };

    if (this.externalSystems.includes(this.fromTab)) {
      data["includeUnlinkedActivities"] = false;
    } else {
      data["includeUnlinkedActivities"] = true;
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getActivityDetails(id: any): Observable<any> {
    const url = `activities-svc/api/activities/${id}`;
    return this._http.get<any>(url, this._authService.ssOptions);
  }

  acceptAssigned(
    Ids: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/assigned/accept`;
    const payload = {
      ids: [Ids]
    };
    return this._http.put<any>(url, payload, this._authService.ssOptions);
  }

  rejectAssigned(
    id: number,
    reason: string,
  ): Observable<any> {
    const url = `activities-svc/api/activities/assigned/reject`;
    let data = {
      ids: [id],
      reason: reason,
    };
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  approveReported(
    Ids: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/reported/approve`;
    const data = {
      ids: [Ids]
    };
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  rejectReported(
    id: number,
    reason: string
  ): Observable<any> {
    const url = `activities-svc/api/activities/reported/reject`;
    let data = {
      ids: [id],
      reason: reason,
    };
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  signed(id: any): Observable<any> {
    const url = `api/IndicatorStemeXe/SignMultiple`;
    let data = {
      Ids: id,
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  rejectMultiple(id: any): Observable<any> {
    const url = `api/IndicatorStemeXe/RejectReportedMultiple`;
    let data = {
      Ids: id,
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  revokeMultiple(id: any): Observable<any> {
    const url = `api/IndicatorStemeXe/RevokeMultiple`;
    let data = {
      Ids: id,
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  follow(
    id: string,
    flag: boolean
  ): Observable<any> {
    const url = `activities-svc/api/activities/${id}/toggle/follow`;
    let data = {
      id: id,
      toggleFlag: flag
    };

    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  unfollow(
    id: string,
    flag: boolean
  ): Observable<any> {
    const url = `activities-svc/api/activities/${id}/toggle/follow`;
    let data = {
      id: id,
      toggleFlag: flag
    };

    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  toggleHealthy(
    id: string,
    flag: boolean
  ): Observable<any> {
    const url = `activities-svc/api/activities/${id}/toggle/healthy`;
    let data = {
      id: id,
      toggleFlag: flag
    };

    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  toggleImportant(
    id: string,
    flag: boolean
  ): Observable<any> {
    const url = `activities-svc/api/activities/${id}/toggle/important`;
    let data = {
      id: id,
      toggleFlag: flag
    };

    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  // delete(
  //   activityId: string,
  //   actionId: number
  // ): Observable<any> {
  //   const url = `api/Indicator/DoAction`;
  //   let data = {
  //     Id: activityId,
  //     action: actionId,
  //   };
  //   return this._http.post<any>(url, data, this._authService.ssOptions);
  // }

  deleteActivity(activityId: number, linkAction?: number, childDates?: any): Observable<any> {
    const data = {
      id: activityId,
      linkAction: linkAction,
      childDates: childDates
    };

    // Merge the body into the options
    const options = {
      ...this._authService.ssOptions,
      body: data
    };

    return this._http.delete<any>(`activities-svc/api/activities/${activityId}`, options);
  }


  updateActualValue(
    data: any
  ): Observable<any> {
    const url = `api/Indicator/UpdateActualValue`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  MoveFromBacklogToInprogressOrPlanned(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/state`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  updateActualValueForActual(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/actuals`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  updateActualValueForComplete(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/complete`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  updateActualValueForCancel(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/cancel`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  updateActualValueForBacklog(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/backlog`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  updateActualValueForReOpen(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/reopen`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  create(data: any, isFromCalender?: any): Observable<any> {
    const url = `activities-svc/api/activities`;
    const options = { headers: this._authService.buildAuthHeader(AuthType.SimpleStrata) };
    options.headers.append("client-id", "web");
    options.headers.append("locale", "en");
    options.headers.append("Content-Type", "application/json");

    let formObject: any = {
      description: data.Description != null ? data.Description : "",
      activityType: data.Type != null ? data.Type : 0, //
      locationType: data.LocationType != null ? data.LocationType : 0,
      showAvailableDatesOnly: data.ShowAvailableDatesOnly != null ? data.ShowAvailableDatesOnly : false,
      targetValueType: data.TargetValueType != null ? data.TargetValueType : 0,
      timeOffType: data.TimeOffCategoryType != null ? data.TimeOffCategoryType : 0,
      dueDate: data.DueDate ? moment(data.DueDate).locale('en').format('YYYY-MM-DD').toString() : null, // Formatting DueDate
      startDate: data.StartDate ? moment(data.StartDate).locale('en').format('YYYY-MM-DD').toString() : null, // Formatting DueDate
      isImportant: data.IsImportant != null ? data.IsImportant : false,
      noteText: data.Note != null ? data.Note : "",
      teamId: data.ParentTeamId != null ? data.ParentTeamId : 0, //
      collaborationBoardId: parseInt(data.CollaborationBoardId) != null ? parseInt(data.CollaborationBoardId) : null,
      tacticId: data.TacticId != null ? data.TacticId : null,
      targetValue: data.TargetValue != null ? data.TargetValue : 0,
      actualValue: data.ActualValue != null ? data.ActualValue : null,
      estimatedValue: data.EstimatedEffort != null ? data.EstimatedEffort : null,
      weight: data.Weight != null ? data.Weight : null,
      ownerUserId: data.Owner_UserId != null ? data.Owner_UserId : null,
      managedByUserId: data.ManagedByUserId != null ? data.ManagedByUserId : null,
      conditionType: data.Condition != null ? data.Condition : 0,
      unit: data.Unit != null ? data.Unit : null,
      dependencyActivityId: data.dependencyActivityId ? data.dependencyActivityId : null,
      distributionType: data.DistributionType != null ? parseInt(data.DistributionType) : 0,
      calendarType: data.CalendarType != null ? data.CalendarType : 1,
      calendarEventId: data.CalendarEventId != null ? data.CalendarEventId : null,
      isShared: data.IsShared != null ? data.IsShared : false,
      maxClaimsAllowed: data.MaxClaims != null ? data.MaxClaims : null,
      sources: data.Sources,
      recurrence: data?.recurrence?.recurrence ? data?.recurrence?.recurrence : null,
      // status: data.Status != null ? data.Status : null, //

    };
    console.log("PayloadData", data);
    if ('markComplete' in data) {
      formObject.markComplete = data.markComplete;
    }

    if (!isFromCalender && data.StartDate != null) {
      formObject.startDate = moment(data.StartDate).locale('en').format('YYYY-MM-DD').toString();
    }

    if (data.ShareWithIds != null && data.ShareWithIds.length > 0) {
      formObject.sharedWithIds = data.ShareWithIds;
    }

    if (data.FollowedBy_UserIds && data.FollowedBy_UserIds.length > 0) {
      formObject.followerIds = data.FollowedBy_UserIds;
    }

    if (!!data && data.EstimatedEfforts && data.EstimatedEfforts.length > 0) {
      formObject.estimatedEfforts = data.EstimatedEfforts.map((distribution: { Date: Date, Hours: number, Minutes: number }) => ({
        date: moment(distribution.Date).locale('en').format('YYYY-MM-DD').toString(),
        hours: distribution.Hours ?? 0,
        minutes: distribution.Minutes ?? 0,
      }));
    }

    if (!!data && data.LogDistributedEfforts && data.LogDistributedEfforts.length > 0) {
      formObject.loggedEfforts = data.LogDistributedEfforts.map((logDistributedEfforts: { CompletedDate: Date, Hours: number, Minutes: number, Note: string, StartTime: Date, EndTime: Date }) => ({
        date: moment(logDistributedEfforts.CompletedDate).locale('en').format('YYYY-MM-DD').toString(),
        hours: logDistributedEfforts.Hours ?? 0,
        minutes: logDistributedEfforts.Minutes ?? 0,
        commentText: logDistributedEfforts?.Note?.toString() || '',
        startTime: logDistributedEfforts.StartTime?.toString() || null,
        endTime: logDistributedEfforts.EndTime?.toString() || null,
      }));
    }

    if (!!data && data.DistributionType != null && data.DistributionType != undefined) {
      formObject.distributionType = data.DistributionType;
    }

    if (!!data && data.Tags && data.Tags.length > 0 && !data.CalendarEventId) {
      formObject.tags = data.Tags.map((tagName: any) => ({
        text: tagName.Name,
        color: tagName.Color,
        textColor: tagName.TextColor,
      }));
    } else if (!!data && data.Tags && data.Tags.length > 0 && data.CalendarEventId) {
      formObject.tags = data.Tags.map((tagName: any) => ({
        text: tagName,
        color: 'aaadb8',
        textColor: 'ffffff',
      }));
    }

    // formObject.Files = data.Files != null ? data.Files : "";

    // if (formObject.sources[0]?.tenantId && formObject.sources[0]?.tenantId !== 0 && formObject.sources[0]?.tenantId !== "0") {
    //   const orgId: any = localStorage.getItem('organziationId');
    //   formObject.sources[0].tenantId = orgId;
    // }

    return this._http.post<any>(url, formObject, options);
  }

  // createRecurring(data: any): Observable<any> {
  //   const url = `api/IndicatorStemeXe/CreateRecurring`;
  //   const options = { headers: this._authService.buildAuthHeader(AuthType.SimpleStrata) };
  //   options.headers.append("client-id", "web");
  //   options.headers.append("locale", "en");
  //   options.headers.append("Content-Type", "application/x-www-form-urlencoded");

  //   let form = new FormData();
  //   form.append("Description", data.Description);
  //   data.TargetValue != null
  //     ? form.append("TargetValue", data.TargetValue)
  //     : "";
  //   data.ActualValue != null
  //     ? form.append("ActualValue", data.ActualValue)
  //     : "";
  //   data.Unit != null ? form.append("Unit", data.Unit) : "";
  //   data.TargetValueType != null ? form.append("TargetValueType", data.TargetValueType) : "";
  //   data.Condition != null ? form.append("Condition", data.Condition) : "";
  //   data.IsImportant != null
  //     ? form.append("IsImportant", data.IsImportant)
  //     : "";
  //   data.IsFollowed != null ? form.append("IsFollowed", data.IsFollowed) : "";
  //   data.TacticId != null ? form.append("TacticId", data.TacticId) : "";
  //   data.Owner_UserId != null
  //     ? form.append("Owner_UserId", data.Owner_UserId)
  //     : "";
  //   data.DueDate != null ? form.append("DueDate", data.DueDate) : "";
  //   data.RecurrenceStartDate != null
  //     ? form.append("RecurrenceStartDate", data.RecurrenceStartDate)
  //     : "";
  //   data.ParentTeamId != null
  //     ? form.append("ParentTeamId", data.ParentTeamId)
  //     : "";
  //   data.ESP_RequestId != null
  //     ? form.append("ESP_RequestId", data.ESP_RequestId)
  //     : "";

  //   data.ESP_RequestNumber != null
  //     ? form.append("ESP_RequestNumber", data.ESP_RequestNumber)
  //     : "";
  //   data.ESP_RequestName != null
  //     ? form.append("ESP_RequestName", data.ESP_RequestName)
  //     : "";
  //   data.IsShared != null ? form.append("IsShared", data.IsShared) : "";

  //   data.CollaborationBoardId ? form.append("CollaborationBoardId", data.CollaborationBoardId) : "";

  //   if (data.ShareWithIds != null && data.ShareWithIds.length > 0) {
  //     for (var i = 0; i < data.ShareWithIds.length; i++) {
  //       form.append("ShareWithIds[" + i + "]", data.ShareWithIds[i]);
  //     }
  //   }
  //   data.MaxClaims != null ? form.append("MaxClaims", data.MaxClaims) : "";
  //   data.Weight != null ? form.append("Weight", data.Weight) : "";
  //   data.Note != null ? form.append("Note", data.Note) : "";
  //   if (data.Effort !== null) {
  //     data.Effort.StartTime != null
  //       ? form.append("Effort.StartTime", data.Effort.StartTime)
  //       : "";
  //     data.Effort.EndTime != null
  //       ? form.append("Effort.EndTime", data.Effort.EndTime)
  //       : "";
  //     data.Effort.Hours != null
  //       ? form.append("Effort.Hours", data.Effort.Hours)
  //       : "";
  //     data.Effort.Minutes != null
  //       ? form.append("Effort.Minutes", data.Effort.Minutes)
  //       : "";
  //     data.Effort.CommentText != null
  //       ? form.append("Effort.CommentText", data.Effort.CommentText)
  //       : "";
  //     data.Effort.CompletedDate != null
  //       ? form.append("Effort.CompletedDate", data.Effort.CompletedDate)
  //       : "";
  //   }

  //   data.Files != null ? form.append("Files", data.Files) : "";

  //   data.RecurrenceInterval != null
  //     ? form.append("RecurrenceInterval", data.RecurrenceInterval)
  //     : "";

  //   data.RecurrenceType != null
  //     ? form.append("RecurrenceType", data.RecurrenceType)
  //     : "";

  //   if (
  //     data.RecurrenceOnWeekDays != null &&
  //     data.RecurrenceOnWeekDays.length > 0
  //   ) {
  //     for (var i = 0; i < data.RecurrenceOnWeekDays.length; i++) {
  //       form.append(
  //         "RecurrenceOnWeekDays[" + i + "]",
  //         data.RecurrenceOnWeekDays[i]
  //       );
  //     }
  //   }

  //   data.RecurrenceEndsOnDate != null
  //     ? form.append("RecurrenceEndsOnDate", data.RecurrenceEndsOnDate)
  //     : "";
  //   data.RecurrenceEndsAfterTimes != null
  //     ? form.append("RecurrenceEndsAfterTimes", data.RecurrenceEndsAfterTimes)
  //     : "";
  //   data.RecurrenceDistribution != null
  //     ? form.append("RecurrenceDistribution", data.RecurrenceDistribution)
  //     : "";

  //   if (data.RecurrenceOnMonthDate != null) {
  //     form.append(
  //       "RecurrenceOnMonthDate.Date",
  //       data.RecurrenceOnMonthDate.Date
  //     );
  //     form.append(
  //       "RecurrenceOnMonthDate.DateType",
  //       data.RecurrenceOnMonthDate.DateType
  //     );
  //   }

  //   if (data.RecurrenceOnMonthDay != null) {
  //     form.append(
  //       "RecurrenceOnMonthDay.WeekDay",
  //       data.RecurrenceOnMonthDay.WeekDay
  //     );
  //     form.append(
  //       "RecurrenceOnMonthDay.WeekDayOccurrence",
  //       data.RecurrenceOnMonthDay.WeekDayOccurrence
  //     );
  //   }

  //   return this._http.post<any>(url, form, options);
  // }

  getRecurringResults(data: any): Observable<any> {
    const url = `activities-svc/api/activities/recurrence`;
    // data["SourceSystemId"] = this.SourceSystemId;
    // data["SourceTenantId"] = this.SourceTenantId;
    // data["SourceObjectTypeId"] = this.SourceObjectTypeId;
    // data["SourceObjectId"] = this.SourceObjectId;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  update(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.Id}`;
    const options = { headers: this._authService.buildAuthHeader(AuthType.SimpleStrata) };
    options.headers.append("client-id", "web");
    options.headers.append("locale", "en");
    options.headers.append("Content-Type", "application/json");

    let formObject: any = {
      id: data.Id,
      description: data.Description != null ? data.Description : "",
      activityType: data.Type != null ? data.Type : 0, //
      locationType: data.LocationType != null ? data.LocationType : 0,
      showAvailableDatesOnly: data.ShowAvailableDatesOnly != null ? data.ShowAvailableDatesOnly : true,
      targetValueType: data.TargetValueType != null ? data.TargetValueType : 0,
      timeOffType: data.TimeOffCategoryType != null ? data.TimeOffCategoryType : 0,
      startDate: data.StartDate ? moment(data.StartDate).locale('en').format('YYYY-MM-DD').toString() : null, // Formatting DueDate
      dueDate: data.DueDate ? moment(data.DueDate).locale('en').format('YYYY-MM-DD').toString() : null, // Formatting DueDate
      isImportant: data.IsImportant != null ? data.IsImportant : true,
      noteText: data.Note != null ? data.Note : "",
      teamId: data.ParentTeamId != null ? data.ParentTeamId : 0, //
      collaborationBoardId: parseInt(data.CollaborationBoardId) != null ? parseInt(data.CollaborationBoardId) : null,
      // tacticId: data.TacticId != null ? data.TacticId : 0,
      targetValue: data.TargetValue != null ? data.TargetValue : 0,
      actualValue: data.ActualValue != null ? data.ActualValue : null,
      estimatedValue: data.EstimatedEffort != null ? data.EstimatedEffort : null,
      weight: data.Weight != null ? data.Weight : 0,
      ownerUserId: data.Owner_UserId != null ? parseInt(data.Owner_UserId) : null,
      managedByUserId: data.ManagedByUserId != null ? data.ManagedByUserId : null,
      conditionType: data.Condition != null ? data.Condition : 1,
      unit: data.Unit != null ? data.Unit : null,
      dependencyActivityId: data.dependencyActivityId ? data.dependencyActivityId : null,
      distributionType: parseInt(data.DistributionType) != null ? parseInt(data.DistributionType) : 0,
      calendarType: data.CalendarType != null ? data.CalendarType : 1,
      calendarEventId: data.CalendarEventId != null ? data.CalendarEventId : "",
      isShared: data.IsShared != null ? data.IsShared : true,
      maxClaimsAllowed: data.MaxClaims != null ? data.MaxClaims : 0,
      sources: data.Sources,
      // recurrence : data.recurrence.recurrence  
      // status: data.Status != null ? data.Status : null, //

    };

    if (data.ShareWithIds != null && data.ShareWithIds.length > 0) {
      formObject.sharedWithIds = data.ShareWithIds;
    }

    if (data.FollowedBy_UserIds && data.FollowedBy_UserIds.length > 0) {
      formObject.followerIds = data.FollowedBy_UserIds;
    }

    if (!!data && data.EstimatedEfforts && data.EstimatedEfforts.length > 0) {
      formObject.estimatedEfforts = data.EstimatedEfforts.map((distribution: { Date: Date, Hours: number, Minutes: number }) => ({
        date: moment(distribution.Date).locale('en').format('YYYY-MM-DD').toString(),
        hours: distribution.Hours ?? 0,
        minutes: distribution.Minutes ?? 0,
      }));
    }

    if (!!data && data.LogDistributedEfforts && data.LogDistributedEfforts.length > 0) {
      formObject.loggedEfforts = data.LogDistributedEfforts.map((logDistributedEfforts: { CompletedDate: Date, Hours: number, Minutes: number, Note: string, StartTime: Date, EndTime: Date }) => ({
        date: moment(logDistributedEfforts.CompletedDate).locale('en').format('YYYY-MM-DD').toString(),
        hours: logDistributedEfforts.Hours ?? 0,
        minutes: logDistributedEfforts.Minutes ?? 0,
        commentText: logDistributedEfforts.Note?.toString() || '',
        startTime: logDistributedEfforts.StartTime?.toString() || null,
        endTime: logDistributedEfforts.EndTime?.toString() || null,
      }));
    }

    if (!!data && data.Tags && data.Tags.length > 0) {
      formObject.tags = data.Tags.map((tagName: any) => ({
        text: tagName.Name,
        color: tagName.Color,
        textColor: tagName.TextColor,
      }));
    }

    return this._http.put<any>(url, formObject, options);
  }

  updateActivityDescription(data: any): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/note`;
    const options = { headers: this._authService.buildAuthHeader(AuthType.SimpleStrata) };
    options.headers.append("client-id", "web");
    options.headers.append("locale", "en");
    options.headers.append("Content-Type", "application/json");


    return this._http.put<any>(url, data, options);
  }

  SearchTeams(data: any): Observable<any> {
    const url = `api/SearchApi/SearchTeams`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  searchForMySpace(data: any): Observable<any> {
    const url = `api/SearchApi/SearchForMySpace`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllByParent(data: any): Observable<any> {
    const url = `api/TacticApi/GetAllByParent`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  searchUsers(data: any): Observable<any> {
    const url = `api/SearchApi/SearchUsers`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  searchUsersWithPaging(data: any): Observable<any> {
    const url = `api/SearchApi/SearchUsersWithPaging`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  async getLabels(): Promise<any> {
    const url = `api/LabelGroup/GetAll`;
    return this._http.get<any>(url, this._authService.ssOptions).toPromise();
  }

  searchUnit(data: any): Observable<any> {
    const url = `api/SearchApi/SearchUnits`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  async getAllConvertedFromCalendar(): Promise<any> {
    const url = `activities-svc/api/activities/calendar`;
    return this._http.get<any>(url, this._authService.ssOptions).toPromise();
  }

  async isEventConvertedToActivity(data: any): Promise<any> {
    const url = `api/IndicatorStemeXe/IsEventConvertedToActivity`;
    return this._http
      .post<any>(url, data, this._authService.ssOptions)
      .toPromise();
  }

  getFiltersForActiveList(
    list: any,
    sprintStartDate?:any,
    sprintEndDate?:any
  ): Observable<any> {
    this.getDataProvider();
    let data1 = {};
    data1["sources"] = this.getSourceSystems();
    if (list?.scoreCardPeriod?.startDate || list?.scoreCardPeriod?.endDate) {
      data1["startDate"] = moment(list?.scoreCardPeriod?.startDate).locale('en').format('YYYY-MM-DD').toString();
      data1["endDate"] = moment(list?.scoreCardPeriod?.endDate).locale('en').format('YYYY-MM-DD').toString();
    }
    if (this.activityType == "ss" && list.type != StemeXeListType.Following && list.type != StemeXeListType.Backlog && list.type != StemeXeListType.User) {
      data1["IsMine"] = true;
    } else if ((this.fromTab == FromTab.ScoreCard || this.fromTab == FromTab.Request || this.fromTab == FromTab.Project || this.fromTab == FromTab.Opportunity) && list.type != StemeXeListType.Following && list.type != StemeXeListType.Backlog && list.type != StemeXeListType.User) {
      data1["IsMine"] = false;
    }

    if (this.TeamId && this.fromTab == FromTab.ScoreCard) {
      data1["TeamId"] = this.TeamId;
    }

    if (list.userId) {
      data1["UserId"] = list.userId;
    }

    let _url: any = null;

    if (this.externalSystems.includes(this.fromTab)) {
      data1["includeUnlinkedActivities"] = false;
    } else {
      data1["includeUnlinkedActivities"] = true;
    }

    if(sprintStartDate || sprintEndDate){
      data1["startDate"] = sprintStartDate ? sprintStartDate : null;
      data1["endDate"] =  sprintEndDate ? sprintEndDate : null;
    }

    switch (list.type) {
      case StemeXeListType.Backlog:
        _url = `activities-svc/api/activities/backlog/filters`;
        return this._http.post<any>(_url, data1, this._authService.ssOptions);
      case StemeXeListType.User:
        _url = `activities-svc/api/activities/user/filters`;
        return this._http.post<any>(_url, data1, this._authService.ssOptions);
      default:
        if (this.externalSystems.includes(this.fromTab) || this.fromTab == FromTab.Members) {
          _url = `activities-svc/api/activities/all/filters`;
          return this._http.post<any>(_url, data1, this._authService.ssOptions);
        }
        else {
          _url = `activities-svc/api/activities/mine/filters`;
          return this._http.post<any>(_url, data1, this._authService.ssOptions);
        }
    }
  }

  reassign(
    data: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/${data.Id}/reassign`;
    const options = { headers: this._authService.buildAuthHeader(AuthType.SimpleStrata) };
    options.headers.append("client-id", "web");
    options.headers.append("locale", "en");
    options.headers.append("Content-Type", "application/x-www-form-urlencoded");

    // let form = new FormData();
    // form.append("Description", data.Description);
    // form.append("ReassignReason", data.ReassignReason);
    // data.Id != null ? form.append("Id", data.Id) : "";
    // data.TargetValue != null
    //   ? form.append("TargetValue", data.TargetValue)
    //   : "";
    // data.ActualValue != null
    //   ? form.append("ActualValue", data.ActualValue)
    //   : "";
    // data.Unit != null ? form.append("Unit", data.Unit) : "";
    // data.IsImportant != null
    //   ? form.append("IsImportant", data.IsImportant)
    //   : "";
    // data.IsFollowed != null ? form.append("IsFollowed", data.IsFollowed) : "";
    // data.TacticId != null ? form.append("TacticId", data.TacticId) : "";
    // data.Owner_UserId != null
    //   ? form.append("Owner_UserId", data.Owner_UserId)
    //   : "";
    // data.AssignedBy_UserId != null
    //   ? form.append("AssignedBy_UserId", data.AssignedBy_UserId)
    //   : "";
    // form.append("DueDate", data.DueDate);
    // data.ParentTeamId != null
    //   ? form.append("ParentTeamId", data.ParentTeamId)
    //   : "";
    // data.Weight != null ? form.append("Weight", data.Weight) : "";
    // data.IsPlanned != null ? form.append("IsPlanned", data.IsPlanned) : "";
    // data.Note != null ? form.append("Note", data.Note) : "";
    // if (data.Effort !== null) {
    //   data.Effort.StartTime != null
    //     ? form.append("Effort.StartTime", data.Effort.StartTime)
    //     : "";
    //   data.Effort.EndTime != null
    //     ? form.append("Effort.EndTime", data.Effort.EndTime)
    //     : "";
    //   data.Effort.Hours != null
    //     ? form.append("Effort.Hours", data.Effort.Hours)
    //     : "";
    //   data.Effort.Minutes != null
    //     ? form.append("Effort.Minutes", data.Effort.Minutes)
    //     : "";
    //   data.Effort.CommentText != null
    //     ? form.append("Effort.CommentText", data.Effort.CommentText)
    //     : "";
    //   data.Effort.CompletedDate != null
    //     ? form.append("Effort.CompletedDate", data.Effort.CompletedDate)
    //     : "";
    // }
    // data.Files != null ? form.append("Files", data.Files) : "";
    // if (data.Sources.length > 0) {
    //   data.Sources.forEach((obj: SourcesModel, i) => {

    //     if (obj.SourceSystemId != null || obj.SourceSystemId != undefined || obj.SourceSystemId != "")
    //       form.append("Sources[" + i + "].SourceSystemId", obj.SourceSystemId);

    //     if (obj.SourceTenantId)
    //       form.append("Sources[" + i + "].SourceTenantId", obj.SourceTenantId);

    //     if (obj.SourceObjectTypeId)
    //       form.append("Sources[" + i + "].SourceObjectTypeId", obj.SourceObjectTypeId);

    //     if (obj.SourceObjectTypeLabel)
    //       form.append("Sources[" + i + "].SourceObjectTypeLabel", obj.SourceObjectTypeLabel);

    //     if (obj.SourceObjectId)
    //       form.append("Sources[" + i + "].SourceObjectId", obj.SourceObjectId);

    //     if (obj.SourceObjectLabel)
    //       form.append("Sources[" + i + "].SourceObjectLabel", obj.SourceObjectLabel);

    //     if (obj.SourceObjectTypeLabelLevel2)
    //       form.append("Sources[" + i + "].SourceObjectTypeLabelLevel2", obj.SourceObjectTypeLabelLevel2);

    //     if (obj.SourceObjectIdLevel2)
    //       form.append("Sources[" + i + "].SourceObjectIdLevel2", obj.SourceObjectIdLevel2);

    //     if (obj.SourceObjectLabelLevel2)
    //       form.append("Sources[" + i + "].SourceObjectLabelLevel2", obj.SourceObjectLabelLevel2);

    //     if (obj.SourceObjectTypeLabelLevel3)
    //       form.append("Sources[" + i + "].SourceObjectTypeLabelLevel3", obj.SourceObjectTypeLabelLevel3);

    //     if (obj.SourceObjectIdLevel3)
    //       form.append("Sources[" + i + "].SourceObjectIdLevel3", obj.SourceObjectIdLevel3);

    //     if (obj.SourceObjectLabelLevel3)
    //       form.append("Sources[" + i + "].SourceObjectLabelLevel3", obj.SourceObjectLabelLevel3);
    //   });
    // }

    // if (!!data && data.Tags && data.Tags.length > 0) {
    //   data.Tags.forEach((tagName: any, i) => {
    //     if (tagName) {
    //       form.append("Tags[" + i + "].Text", tagName.Name);
    //       form.append("Tags[" + i + "].Color", tagName.Color);
    //       form.append("Tags[" + i + "].TextColor", tagName.TextColor);
    //     }
    //   });
    // }



    let formObject: any = {
      id: data.Id,
      reason: data.ReassignReason,
      description: data.Description != null ? data.Description : "",
      activityType: data.Type != null ? data.Type : 0, //
      locationType: data.LocationType != null ? data.LocationType : 0,
      showAvailableDatesOnly: data.ShowAvailableDatesOnly != null ? data.ShowAvailableDatesOnly : true,
      targetValueType: data.TargetValueType != null ? data.TargetValueType : 0,
      timeOffType: data.TimeOffCategoryType != null ? data.TimeOffCategoryType : 0,
      startDate: data.StartDate ? moment(data.StartDate).locale('en').format('YYYY-MM-DD').toString() : null, // Formatting DueDate
      endDate: data.DueDate ? moment(data.DueDate).locale('en').format('YYYY-MM-DD').toString() : null, // Formatting DueDate
      isImportant: data.IsImportant != null ? data.IsImportant : true,
      noteText: data.Note != null ? data.Note : "",
      teamId: data.ParentTeamId != null ? data.ParentTeamId : 0, //
      collaborationBoardId: parseInt(data.CollaborationBoardId) != null ? parseInt(data.CollaborationBoardId) : null,
      // tacticId: data.TacticId != null ? data.TacticId : 0,
      targetValue: data.TargetValue != null ? data.TargetValue : 0,
      actualValue: data.ActualValue != null ? data.ActualValue : 0,
      estimatedValue: data.EstimatedEffort != null ? data.EstimatedEffort : null,
      weight: data.Weight != null ? data.Weight : 0,
      ownerUserId: data.Owner_UserId != null ? parseInt(data.Owner_UserId) : null,
      managedByUserId: data.ManagedByUserId != null ? data.ManagedByUserId : null,
      conditionType: data.Condition != null ? data.Condition : 1,
      unit: data.Unit != null ? data.Unit : null,
      distributionType: parseInt(data.DistributionType) != null ? parseInt(data.DistributionType) : 0,
      calendarType: data.CalendarType != null ? data.CalendarType : 1,
      calendarEventId: data.CalendarEventId != null ? data.CalendarEventId : "",
      isShared: data.IsShared != null ? data.IsShared : true,
      maxClaimsAllowed: data.MaxClaims != null ? data.MaxClaims : 0,
      sources: data.Sources,
      // recurrence : data.recurrence.recurrence  
      // status: data.Status != null ? data.Status : null, //

    };

    if (data.ShareWithIds != null && data.ShareWithIds.length > 0) {
      formObject.sharedWithIds = data.ShareWithIds;
    }

    if (data.FollowedBy_UserIds && data.FollowedBy_UserIds.length > 0) {
      formObject.followerIds = data.FollowedBy_UserIds;
    }

    if (!!data && data.EstimatedEfforts && data.EstimatedEfforts.length > 0) {
      formObject.estimatedEfforts = data.EstimatedEfforts.map((distribution: { Date: Date, Hours: number, Minutes: number }) => ({
        date: moment(distribution.Date).locale('en').format('YYYY-MM-DD').toString(),
        hours: distribution.Hours,
        minutes: distribution.Minutes,
      }));
    }

    if (!!data && data.LogDistributedEfforts && data.LogDistributedEfforts.length > 0) {
      formObject.loggedEfforts = data.LogDistributedEfforts.map((logDistributedEfforts: { CompletedDate: Date, Hours: number, Minutes: number, Note: string, StartTime: Date, EndTime: Date }) => ({
        date: moment(logDistributedEfforts.CompletedDate).locale('en').format('YYYY-MM-DD').toString(),
        hours: logDistributedEfforts.Hours || 0,
        minutes: logDistributedEfforts.Minutes || 0,
        commentText: logDistributedEfforts.Note?.toString() || '',
        startTime: logDistributedEfforts.StartTime?.toString() || null,
        endTime: logDistributedEfforts.EndTime?.toString() || null,
      }));
    }

    if (!!data && data.Tags && data.Tags.length > 0) {
      formObject.tags = data.Tags.map((tagName: any) => ({
        text: tagName.Name,
        color: tagName.Color,
        textColor: tagName.TextColor,
      }));
    }


    return this._http.put<any>(url, formObject, options);
  }


  claim(id: string): Observable<any> {
    const url = `activities-svc/api/activities/shared/claim`;
    const data = {
      ids: [id]
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  stopClaiming(id: string): Observable<any> {
    const url = `activities-svc/api/activities/shared/stop-claims`;
    const data = {
      ids: [id]
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  completeClaimed(id: string): Observable<any> {
    const url = `activities-svc/api/activities/claimed/complete`;
    const data = {
      ids: [id]
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  cancelClaimed(id: string): Observable<any> {
    const url = `activities-svc/api/activities/claimed/cancel`;
    const data = {
      ids: [id]
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  updateEPMSettings(data: any): Observable<any> {
    const url = `api/UserApi/UpdateEPMSettings`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  isAdmin(): Observable<any> {
    const url = `api/UserApi/IsAdmin`;
    return this._http.get<any>(url, this._authService.ssOptions);
  }

  // removeEPMSettings() {
  //   const url = `api/UserApi/RemoveEPMSettings`;
  //   return this._http.get<any>(url, this._authService.ssOptions);
  // }

  // searchProjects(data: any): Observable<any> {
  //   const url = `api/IndicatorStemeXe/EPM/SearchProjects`;
  //   return this._http.post<any>(url, data, this._authService.ssOptions);
  // }

  // createEPMActivity(data: any): Observable<any> {
  //   const url = `api/IndicatorStemeXe/EPM/Create`;
  //   return this._http.post<any>(url, data, this._authService.ssOptions);
  // }

  // updateEPMActivity(data: any): Observable<any> {
  //   const url = `api/IndicatorStemeXe/EPM/Update`;
  //   return this._http.post<any>(url, data, this._authService.ssOptions);
  // }

  getAllSigned(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetAllSignedForFollowing`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      isLagging?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      ownerUserIds?: number;
      IsSigned?: any;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    if (!!filter.GroupInfo) {
      data.GroupInfo = {
        StartDate: filter.GroupInfo.StartDate,
        EndDate: filter.GroupInfo.EndDate,
      };
    }

    let forFilter = false;
    let newFilter: any = {};
    if (!!filter.FromFilter) {
      forFilter = true;
      newFilter["PageIndex"] = pageIndex;
      newFilter["PageSize"] = pageSize;
      newFilter["GroupInfo"] = filter.GroupInfo;
      newFilter["GroupType"] = filter.GroupType;
      newFilter["IsSigned"] = filter.IsSigned;
      newFilter["StatusIds"] = filter.StatusIds;
      newFilter["ownerUserIds"] = filter.ownerUserIds;
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      } else {
        data.CreatorIds = [];
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      } else {
        data.TeamIds = [];
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      } else {
        data.TacticIds = [];
      }

      if (!!filter.GroupType) {
        data.GroupType = filter.GroupType;
      }

      if (!!filter.ownerUserIds) {
        data.ownerUserIds = filter.ownerUserIds;
      }

      if (!!filter.IsSigned == null || filter.IsSigned || !filter.IsSigned) {
        data.IsSigned = filter.IsSigned;
      }
    }

    return this._http.post<any>(url, !forFilter ? data : newFilter, this._authService.ssOptions);
  }

  getCountForSigned(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetSignedCountForFollowing`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      isLagging?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      ownerUserIds?: number;
      IsSigned?: any;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    if (!!filter.GroupInfo) {
      data.GroupInfo = {
        StartDate: filter.GroupInfo.StartDate,
        EndDate: filter.GroupInfo.EndDate,
      };
    }

    let forFilter = false;
    let newFilter: any = {};
    if (!!filter.FromFilter) {
      forFilter = true;
      newFilter["PageIndex"] = pageIndex;
      newFilter["PageSize"] = pageSize;
      newFilter["GroupInfo"] = filter.GroupInfo;
      newFilter["GroupType"] = filter.GroupType;
      newFilter["IsSigned"] = filter.IsSigned;
      newFilter["StatusIds"] = filter.StatusIds;
      newFilter["ownerUserIds"] = filter.ownerUserIds;
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      } else {
        data.CreatorIds = [];
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      } else {
        data.TeamIds = [];
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      } else {
        data.TacticIds = [];
      }

      if (!!filter.GroupType) {
        data.GroupType = filter.GroupType;
      }

      if (!!filter.ownerUserIds) {
        data.ownerUserIds = filter.ownerUserIds;
      }

      if (!!filter.IsSigned == null || filter.IsSigned || !filter.IsSigned) {
        data.IsSigned = filter.IsSigned;
      }
    }

    return this._http.post<any>(url, !forFilter ? data : newFilter, this._authService.ssOptions);
  }

  getAllRejected(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetAllRejectedForFollowing`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      isLagging?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      ownerUserIds?: number;
      IsSigned?: any;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    if (!!filter.GroupInfo) {
      data.GroupInfo = {
        StartDate: filter.GroupInfo.StartDate,
        EndDate: filter.GroupInfo.EndDate,
      };
    }

    let forFilter = false;
    let newFilter: any = {};
    if (!!filter.FromFilter) {
      forFilter = true;
      newFilter["PageIndex"] = pageIndex;
      newFilter["PageSize"] = pageSize;
      newFilter["GroupInfo"] = filter.GroupInfo;
      newFilter["GroupType"] = filter.GroupType;
      newFilter["IsSigned"] = filter.IsSigned;
      newFilter["StatusIds"] = filter.StatusIds;
      newFilter["ownerUserIds"] = filter.ownerUserIds;
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      } else {
        data.CreatorIds = [];
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      } else {
        data.TeamIds = [];
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      } else {
        data.TacticIds = [];
      }

      if (!!filter.GroupType) {
        data.GroupType = filter.GroupType;
      }

      if (!!filter.ownerUserIds) {
        data.ownerUserIds = filter.ownerUserIds;
      }

      if (!!filter.IsSigned == null || filter.IsSigned || !filter.IsSigned) {
        data.IsSigned = filter.IsSigned;
      }
    }

    return this._http.post<any>(url, !forFilter ? data : newFilter, this._authService.ssOptions);
  }

  getCountForRejected(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    filter?: any,
  ): Observable<any> {
    const url = `api/IndicatorStemeXe/GetRejectedCountForFollowing`;
    let data: {
      Keyword: string;
      GroupType: number;
      PageIndex: number;
      PageSize: number;
      CreatorIds?: Array<any>;
      DueDate?: any;
      StatusIds?: Array<any>;
      IsImportant?: any;
      isLagging?: any;
      IsFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      GroupInfo?: any;
      ownerUserIds?: number;
      IsSigned?: any;
    } = {
      GroupType: groupType,
      Keyword: keyword,
      PageIndex: pageIndex,
      PageSize: pageSize,
    };

    if (!!filter.GroupInfo) {
      data.GroupInfo = {
        StartDate: filter.GroupInfo.startDate,
        EndDate: filter.GroupInfo.endDate,
      };
    }

    let forFilter = false;
    let newFilter: any = {};
    if (!!filter.FromFilter) {
      forFilter = true;
      newFilter["PageIndex"] = pageIndex;
      newFilter["PageSize"] = pageSize;
      newFilter["GroupInfo"] = filter.GroupInfo;
      newFilter["GroupType"] = filter.GroupType;
      newFilter["IsSigned"] = filter.IsSigned;
      newFilter["StatusIds"] = filter.StatusIds;
      newFilter["ownerUserIds"] = filter.ownerUserIds;
    }

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.CreatorIds = filter.CreatorIds;
      } else {
        data.CreatorIds = [];
      }
      if (!!filter.DueDate) {
        data.DueDate = filter.DueDate;
      }
      if (!!filter.StatusIds) {
        data.StatusIds = filter.StatusIds;
      }

      filter.IsImportant == true ? (data.IsImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.IsSigned = filter.IsSigned) : "";
      data.IsFollowed = filter.IsFollowed;

      if (!!filter.TeamIds) {
        data.TeamIds = filter.TeamIds;
      } else {
        data.TeamIds = [];
      }

      if (!!filter.TacticIds) {
        data.TacticIds = filter.TacticIds;
      } else {
        data.TacticIds = [];
      }

      if (!!filter.GroupType) {
        data.GroupType = filter.GroupType;
      }

      if (!!filter.ownerUserIds) {
        data.ownerUserIds = filter.ownerUserIds;
      }

      if (!!filter.IsSigned == null || filter.IsSigned || !filter.IsSigned) {
        data.IsSigned = filter.IsSigned;
      }
    }

    return this._http.post<any>(url, !forFilter ? data : newFilter, this._authService.ssOptions);
  }

  GetCurrentWeekForMine(StartDate: any = null, EndDate: any = null): Observable<any> {
    this.getDataProvider();
    const url = `activities-svc/api/activities/mine/week`;
    let data = {
      sources: this.getSourceSystems(),
      startDate: StartDate,
      endDate: EndDate
    };

    if (this.externalSystems.includes(this.fromTab)) {
      data["includeUnlinkedActivities"] = false;
    } else {
      data["includeUnlinkedActivities"] = true;
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  fetchMockTags(): Observable<any> {
    return this._http.get('assets/mock/tags.json');
  }

  getAllTags(keyword: any): Observable<any> {
    const url = `api/SearchApi/SearchTags`;
    return this._http.post<any>(url, { Name: keyword }, this._authService.ssOptions);
  }

  getAllTagColors(): Observable<any> {
    const url = `api/Tag/GetAllColors`;
    return this._http.get<any>(url, this._authService.ssOptions);
  }

  fetchGroupTags(keyword: any): Observable<IActivityTag[]> {
    const url = `api/SearchApi/SearchTags`;
    return this._http.post(url, { Name: keyword }, this._authService.ssOptions).pipe(
      map(
        (data: any) => {
          const tags: IActivityTag[] = [];
          for (const tag of data.ResponseResult) {
            tags.push(
              {
                Name: tag.Name, TextColor: tag.TextColor, Color: tag.Color, LastEditedBy: '', LastEditedOn: '', IsDeleted: false, UserIdenedi: '', InstanceId: '', EntityType: '', MainColor: tag.MainColor
              }
            );
          }
          const pipe = new TextSortPipe();
          pipe.transform(tags, 'Name');
          return tags;
        }
      ),
      catchError(
        errorRes => {
          return throwError(errorRes);
        }
      )
    );
  }

  getAllBookedDates(UserId: number): Observable<any> {
    const url = `activities-svc/api/activities/booked-dates?timestamp=${new Date().getTime()}&UserId=${UserId}`;
    return this._http.get<any>(url, this._authService.ssOptions);
  }

  getAllAdditionalField(data: { EntityId: number, EntityType: number }): Observable<any> {
    const url = `api/FieldStemeXe/GetAllForCreate`;
    return this._http.post<any>(url, { EntityId: data.EntityId, EntityType: data.EntityType }, this._authService.ssOptions);
  }


  createAllAdditionalField(data: { FieldValues: Array<ICreate>, EntityId: number, EntityType: number }): Observable<any> {
    const url = `api/FieldValue/CreateMultiple`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getEstimatedEffortDistribution(data: { Hours: number, Minutes: number, StartDate: any, EndDate: any }): Observable<any> {
    const url = `activities-svc/api/activities/efforts-distribution?Hours=${data.Hours}&Minutes=${data.Minutes}&StartDate=${data.StartDate}&EndDate=${data.EndDate}`;

    return this._http.get<any>(url, this._authService.ssOptions);
  }

  manageActivity(data: { Id: number }): Observable<any> {
    const url = `api/IndicatorStemeXe/UpdateAssignor`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  unManageActivity(data: { id: number }): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/unmanage`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  claimActivity(data: { Id: number }): Observable<any> {
    const url = `api/IndicatorStemeXe/claim`;
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  signActivity(data: { id: number }): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/sign`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  revokeActivity(data: { id: number }): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/revoke`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  getMainAccessTokenFromSSServer(): Observable<any> {
    const url = `api/User/Calendar/GetAll`;
    return this._http.get<any>(url, this._authService.ssOptions)
  }

  GetCategoriesForTimeOff(): Observable<any> {
    const url = `api/IndicatorStemeXe/GetCategoriesForTimeOff`;
    return this._http.get<any>(url, this._authService.ssOptions)
  }

  getAllForKeyPoint(
    pageSize: number,
    pageIndex: number,
    KeyPointId: number,
    SortBy?: number,
    filter?: any,
    source?: any,
    TeamUserId?: any,
    isFromPeriod?: boolean
  ): Observable<any> {
    const url = `activities-svc/api/activities/all`;
    let data: {
      pageNumber: number;
      pageSize: number;
      // KeyPointId: number;
      keyword?: string;
      // groupType:any;
      creatorIds?: Array<any>;
      ownerIds?: Array<any>;
      OwnershipTypeIds?: Array<any>;
      followerIds?: Array<any>;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isFollowed?: any;
      tags?: Array<any>;
      typeIds?: Array<any>;
      startDate?: any;
      endDate?: any;
      // includeBeforeDueDate?: boolean;
      isOverdue?: boolean;
      isManaged?: any;
      sources: any;
      managerIds?: Array<any>;
      isSigned?: any;
      isHealthy?: any;
      userId: any
      sortBy: any
      includeUnlinkedActivities: any;
      TeamIds?: any;
      viewMode?: any;
    } = {
      pageNumber: pageIndex,
      pageSize: pageSize,
      sources: null,
      userId: TeamUserId,
      sortBy: SortBy ? SortBy : 0,
      includeUnlinkedActivities: true,
    };

    if (!!filter) {
      if (!!filter.Keyword) {
        data.keyword = filter.Keyword;
      } else {
        data.keyword = "";
      }


      if (!!filter.StartDate) {
        data.startDate = moment(filter.StartDate).locale('en').format("YYYY-MM-DD").toString();
      }


      if (!!filter.EndDate) {
        data.endDate = moment(filter.EndDate).locale('en').format("YYYY-MM-DD").toString();
      }
    }

    console.log('getAllForKeyPoint', filter)
    console.log('getAllForKeyPoint2', isFromPeriod)
    if (isFromPeriod) {
      if (!!filter) {
        if (!!filter.CreatorIds) {
          data.creatorIds = filter.CreatorIds;
        } else {
          data.creatorIds = [];
        }
        if (!!filter.AssignedByUserIds) {
          data.managerIds = filter.AssignedByUserIds;
        } else {
          data.managerIds = [];
        }
        if (!!filter.AssignToIds) {
          data.ownerIds = filter.AssignToIds;
        } else {
          data.ownerIds = [];
        }
        if (!!filter.FollowedByIds) {
          data.followerIds = filter.FollowedByIds;
        } else {
          data.followerIds = [];
        }

        if (filter.IncludeOnOrBeforeDueDate != null && filter.IncludeOnOrBeforeDueDate != undefined && !!filter.startDate) {
          if (!filter.IncludeOnOrBeforeDueDate) {
            data.startDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
            data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
          } else {
            data.startDate = null;
            data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
          }
        }

        if (!!filter.StatusIds) {
          data.statusIds = filter.StatusIds;
        }

        if (!!filter.ActivitySortBy) {
          data.sortBy = filter.ActivitySortBy;
        } else {
          data.sortBy = data.sortBy || 0;
        }

        if (this.forSprint) {
          data.isFollowed = false;
        }

        filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
        filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
        filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
        data.isFollowed = filter.IsFollowed;
        data.isManaged = filter.IsManaged;

        if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
          data.isHealthy = filter.IsHealthy;
        else data.isHealthy = null;

        if (!!filter.TagIds) {
          data.tags = filter.TagIds;
        } else {
          data.tags = [];
        }

        if (!!filter.TeamIds) {
          data.TeamIds = filter.TeamIds;
        } else {
          data.TeamIds = [];
        }

        if (!!filter.Type && filter.Type.length == 1) {
          data.typeIds = filter.Type;
        } else {
          data.typeIds = [];
        }

        if (!!filter.ActivityStartDate) {
          data.startDate = moment(filter.ActivityStartDate).locale('en').format("YYYY-MM-DD");
        }
        if (!!filter.DueDate) {
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        }
        this.applyFilterForSources(filter, data);
      }
    }

    if (!!filter.viewMode) {
      data.viewMode = filter.viewMode;
    }

    this.route.queryParams.subscribe((params) => {
      this.boardId = this.route.snapshot.params.boardId;
      this.keyPointId = this.route.snapshot.params.keyPointId;
      console.log("Params", params);
      this.updateParams(params);
    });

    if (this.externalSystems.includes(this.fromTab)) {
      if (this.fromTab == FromTab.ScoreCard) {
        data["includeUnlinkedActivities"] = true;
      }
      else {
        data["includeUnlinkedActivities"] = false;
      }
    } else {
      data["includeUnlinkedActivities"] = true;
    }

    // this.getDataProvider();
    if (source) {
      console.log('@ActivityService', source)
      data.sources = source;
    } else {
      console.log('@else')
      console.log('@ActivityServiceelse', source)
      data.sources = this.getSourceSystems();
    }

    if (this.fromTab == 'Members' && source) {
      this.applyFilterForSources(filter, data)
    }
    // StatusIds must apply on the member dashboard widget too (isFromPeriod is false there).
    // Without this, Cancelled activities inflate totalCount vs Open + Completed.
    if (!!filter?.StatusIds && !data.statusIds) {
      data.statusIds = filter.StatusIds;
    }
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getPeriodStats(
    filter?: any,
    source?: any,
    TeamUserId?: any
  ): Observable<any> {
    const url = `activities-svc/api/activities/period/stats`;
    let data: {
      startDate?: any;
      endDate?: any;
      sources: any;
      userId: any
    } = {
      sources: null,
      userId: TeamUserId,
    };

    if (!!filter) {
      if (!!filter.StartDate) {
        data.startDate = moment(filter.StartDate).locale('en').format("YYYY-MM-DD").toString();
      }
      if (!!filter.EndDate) {
        data.endDate = moment(filter.EndDate).locale('en').format("YYYY-MM-DD").toString();
      }
    }
    this.route.queryParams.subscribe((params) => {
      this.boardId = this.route.snapshot.params.boardId;
      this.keyPointId = this.route.snapshot.params.keyPointId;
      console.log("Params", params);
      this.updateParams(params);
    });
    if (source) {
      data.sources = source;
    }
    else {
      data.sources = this.getSourceSystems();
    }
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getColor(startDate: Date, dueDate: Date, actual: number, target: number): string {
    if (actual === target || !startDate) {
      return '#33ba70';
    }

    if (dueDate !== null && dueDate !== undefined && dueDate > new Date()) {
      let todayTarget = 0;
      const daysBetweenStartDue = this.getDateDifference(startDate, dueDate);
      const perDayTarget = daysBetweenStartDue != 0 ? target / daysBetweenStartDue : 0;
      const daysBetweenStartCurrent = this.getDateDifference(new Date(), startDate);
      todayTarget = ((perDayTarget * (daysBetweenStartCurrent * 1.00)))
      if (actual >= todayTarget) return '#33ba70';
      else return '#FFA500';
    } else return '#FFA500';
  }

  getDateDifference(date1: Date, date2: Date): number {
    const startDate = new Date(date1);
    const endDate = new Date(date2);
    const differenceInMs = endDate.getTime() - startDate.getTime();
    const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
    return differenceInDays;
  }


  reorderBoardBacklog(data: { id: number, idBefore: number, idAfter: number }): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/reorder/board-backlog`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  reorderBacklog(data: { id: number, idBefore: number, idAfter: number }): Observable<any> {
    const url = `activities-svc/api/activities/${data.id}/reorder/backlog`;
    return this._http.put<any>(url, data, this._authService.ssOptions);
  }

  claimMultiple(ids: number[]): Observable<any> {
    const url = `activities-svc/api/activities/shared/claim`;
    return this._http.put<any>(url, { ids }, this._authService.ssOptions);
  }

  acceptAssignedMultiple(ids: number[]): Observable<any> {
    const url = `activities-svc/api/activities/assigned/accept`;
    return this._http.put<any>(url, { ids }, this._authService.ssOptions);
  }

  approveReportedMultiple(Ids: number[]): Observable<any> {
    const url = `activities-svc/api/activities/reported/approve`;
    const payload = {
      ids: Ids
    };
    return this._http.put<any>(url, payload, this._authService.ssOptions);
  }

  rejectReportedMultiple(Ids: number[]): Observable<any> {
    const url = `activities-svc/api/activities/reported/reject`;
    const payload = {
      ids: Ids
    };
    return this._http.put<any>(url, payload, this._authService.ssOptions);
  }

  rejectAssignedMultiple(ids: number[]): Observable<any> {
    const url = `activities-svc/api/activities/assigned/reject`;
    return this._http.put<any>(url, { ids }, this._authService.ssOptions);
  }

  GetAllByEntity(id: number): Observable<any> {
    const url = `api/Attachment/GetAllByEntity`;
    let data = {
      EntityId: id,
      EntityType: 7
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  GetActivtiesComments(id: any): Observable<any> {
    const url = `api/CommentStemeXe/GetAllByParent`;
    let data = {
      Indicator_IndicatorId: id,
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  checkPrimaryOrganization(sourceSystemList: any[] | null): boolean | null {
    const allowedSystems = [DataProviderSourceSystem.SimpleStrata];
    console.log('sourceSystemList', sourceSystemList)
    const sourceSystem = sourceSystemList?.find(it => allowedSystems.includes(it.systemId));
    if (!sourceSystem) return true;

    const tenantId = sourceSystem.tenantId;

    const organizationId = localStorage.getItem("organziationId");
    const orgId = organizationId.length > 0 ? parseInt(organizationId) : null;

    return (tenantId !== null && orgId !== null && tenantId === orgId);
  }

  public updateParams(params: any): void {
    this.SourceSystemId = params["SourceSystemId"] ? +params["SourceSystemId"] : null;
    this.SourceTenantId = params["SourceTenantId"] ? +params["SourceTenantId"] : null;
    this.SourceObjectTypeId = params["SourceObjectTypeId"] ? +params["SourceObjectTypeId"] : null;
    this.SourceObjectId = params["SourceObjectId"] ? +params["SourceObjectId"] : null;
    if (this.keyPointId) {
      this.SourceObjectId = this.keyPointId
    }
    if (this.SourceSystemId == DataProviderSourceSystem.Technadopt) {
      this.SourceObjectId = params["SourceObjectId"];
    }
    this.TeamId = params["teamId"] ? +params["teamId"] : null;
    if (this.boardId) {
      this.TeamId = this.boardId
    }
    this.requirementId = params["requirementId"] ? params["requirementId"] : null;
    this.deliverableId = params["deliverableId"] ? params["deliverableId"] : null;
    this.activityType = params["activityType"] ? params["activityType"] : null;
    this.boardOwnerId = params["boardOwnerId"] ? params["boardOwnerId"] : null;
    this.fromTab = params["fromTab"] ? params["fromTab"] : null;
    this.bugId = params["bugId"] ? params["bugId"] : null;
    this.bugName = params["bugName"] ? params["bugName"] : null;
    this.forSprint = params["forSprint"] === 'true';
    this.riskId = params['riskId'] || ''
    this.sprintId = params['sprintId'] || '';
  }

  transcribeAudio(body: FormData): Observable<any> {

    const url = `ai-svc/api/activity/Transcribe`;
    const options = this._authService.ssOptions;
    console.log('options', options);
    options.headers.append('content-type', 'multipart/form-data')

    return this._http.post<any>(url, body, options);
  }

  normalizeHoursAndMinutes(hours: number, minutes: number): { hours: number; minutes: number } {
    const totalMinutes = hours * 60 + minutes;   // Convert hours to minutes and add
    const normalizedHours = Math.floor(totalMinutes / 60);  // Calculate new hours
    const remainingMinutes = totalMinutes % 60;             // Calculate remaining minutes
    return { hours: normalizedHours, minutes: remainingMinutes };
  }

  getPredictedActivities(args: PredictedActivityPayload): any {
    const url = `ai-svc/api/activity/PredictActivitites`;
    const options = this._authService.ssOptions;

    return this._http.post<any>(url, args, options);
  }

  createBulkActivities(args: any): Observable<any> {
    const url = `activities-svc/api/activities/bulk`;
    return this._http.post<any>(url, args, this._authService.ssOptions);
  }

  getDashboardDataForUser(UserId: any, StartDate: any = null, EndDate: any = null, sources: any): Observable<any> {
    let exceedIdenediId: any
    this.getDataProvider();
    const url = `api/MeasureStemeXe/GetDashboardByUser`;

    const idenediId = localStorage.getItem('user.chosen.idenedi.group.id');
    if (localStorage.getItem('e.user')) {
      exceedIdenediId = JSON.parse(localStorage.getItem('e.user'));
    }

    let data = {
      UserId: UserId,
      StartDate: StartDate,
      EndDate: EndDate,
      SourceSystems: sources,
      IdenediGroupId: idenediId ?? exceedIdenediId?.linkedGroupId
    };
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllForTimeoffActivities(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
  ): Observable<any> {
    const data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      ownerIds?: Array<any>;
      // OwnershipTypeIds?:Array<any>;
      followerIds?: Array<any>;
      // OpportunityIds?: Array<any>;
      // CustomerIds?: Array<any>;
      // SalesJobIds?: Array<any>;
      endDate?: any;
      activityStartDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isHealthy?: any;
      isManaged?: any;
      GroupInfo?: any;
      viewMode?: number;
      tags?: Array<any>;
      typeIds?: Array<any>;
      // includeBeforeDueDate?: boolean;
      sortBy?: number;
      managerIds?: Array<any>
      sources?: Array<any>
    } = {
      groupType: 0,
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
    };

    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    console.log('@filterData', filter)
    this.getDataProvider();

    if (!!filter.AssignedByUserIds) {
      data.managerIds = filter.AssignedByUserIds;
    } else {
      data.managerIds = [];
    }
    data.statusIds = [6, 5, 2];
    data.sortBy = 0;
    data.typeIds = [2];
    data.viewMode = filter?.ViewBy || ActivityViewByType.Activity;
    data.sources = this.getSourceSystems();
    data["startDate"] = filter.startDate;
    data["endDate"] = filter.endDate;
    this.applyFilterForSources(filter, data)

    var url = `activities-svc/api/activities/all`;
    data["includeUnlinkedActivities"] = true;

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }


  exportallActivitiesToExcel(
    pageSize: number,
    pageIndex: number,
    KeyPointId: number,
    SortBy?: number,
    filter?: any,
    source?: any,
    TeamUserId?: any,
    isFromPeriod?: boolean
  ): Observable<any> {
    const url = `activities-svc/api/activities/all/export/csv`;
    let data: {
      pageNumber: number;
      pageSize: number;
      // KeyPointId: number;
      keyword?: string;
      // groupType:any;
      creatorIds?: Array<any>;
      ownerIds?: Array<any>;
      OwnershipTypeIds?: Array<any>;
      followerIds?: Array<any>;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isFollowed?: any;
      tags?: Array<any>;
      typeIds?: Array<any>;
      startDate?: any;
      endDate?: any;
      // includeBeforeDueDate?: boolean;
      isOverdue?: boolean;
      isManaged?: any;
      sources: any;
      managerIds?: Array<any>;
      isSigned?: any;
      isHealthy?: any;
      userId: any
      sortBy: any
      includeUnlinkedActivities: any;
      TeamIds?: any;
    } = {
      pageNumber: pageIndex,
      pageSize: pageSize,
      sources: null,
      userId: TeamUserId,
      sortBy: SortBy ? SortBy : 0,
      includeUnlinkedActivities: true,
    };

    if (!!filter) {
      if (!!filter.Keyword) {
        data.keyword = filter.Keyword;
      } else {
        data.keyword = "";
      }


      if (!!filter.StartDate) {
        data.startDate = moment(filter.StartDate).locale('en').format("YYYY-MM-DD").toString();
      }


      if (!!filter.EndDate) {
        data.endDate = moment(filter.EndDate).locale('en').format("YYYY-MM-DD").toString();
      }
    }

    console.log('getAllForKeyPoint', filter)
    console.log('getAllForKeyPoint2', isFromPeriod)
    if (isFromPeriod) {
      if (!!filter) {
        if (!!filter.CreatorIds) {
          data.creatorIds = filter.CreatorIds;
        } else {
          data.creatorIds = [];
        }
        if (!!filter.AssignedByUserIds) {
          data.managerIds = filter.AssignedByUserIds;
        } else {
          data.managerIds = [];
        }
        if (!!filter.AssignToIds) {
          data.ownerIds = filter.AssignToIds;
        } else {
          data.ownerIds = [];
        }
        if (!!filter.FollowedByIds) {
          data.followerIds = filter.FollowedByIds;
        } else {
          data.followerIds = [];
        }

        if (filter.IncludeOnOrBeforeDueDate != null && filter.IncludeOnOrBeforeDueDate != undefined && !!filter.startDate) {
          if (!filter.IncludeOnOrBeforeDueDate) {
            data.startDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
            data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
          } else {
            data.startDate = null;
            data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
          }
        }

        if (!!filter.StatusIds) {
          data.statusIds = filter.StatusIds;
        }

        if (!!filter.ActivitySortBy) {
          data.sortBy = filter.ActivitySortBy;
        } else {
          data.sortBy = data.sortBy || 0;
        }

        if (this.forSprint) {
          data.isFollowed = false;
        }

        filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
        filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
        filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
        data.isFollowed = filter.IsFollowed;
        data.isManaged = filter.IsManaged;

        if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
          data.isHealthy = filter.IsHealthy;
        else data.isHealthy = null;

        if (!!filter.TagIds) {
          data.tags = filter.TagIds;
        } else {
          data.tags = [];
        }

        if (!!filter.TeamIds) {
          data.TeamIds = filter.TeamIds;
        } else {
          data.TeamIds = [];
        }

        if (!!filter.Type && filter.Type.length == 1) {
          data.typeIds = filter.Type;
        } else {
          data.typeIds = [];
        }

        if (!!filter.ActivityStartDate) {
          data.startDate = moment(filter.ActivityStartDate).locale('en').format("YYYY-MM-DD");
        }
        if (!!filter.DueDate) {
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        }
        this.applyFilterForSources(filter, data);
      }
    }

    this.route.queryParams.subscribe((params) => {
      this.boardId = this.route.snapshot.params.boardId;
      this.keyPointId = this.route.snapshot.params.keyPointId;
      console.log("Params", params);
      this.updateParams(params);
    });

    if (this.externalSystems.includes(this.fromTab)) {
      if (this.fromTab == FromTab.ScoreCard || this.fromTab == FromTab.Members || this.fromTab == FromTab.Listing || this.fromTab == FromTab.Actions || this.fromTab == FromTab.All) {
        data["includeUnlinkedActivities"] = true;
      }
      else {
        data["includeUnlinkedActivities"] = false;
      }
    } else {
      data["includeUnlinkedActivities"] = true;
    }

    // this.getDataProvider();
    if (source) {
      console.log('@ActivityService', source)
      data.sources = source;
    } else {
      console.log('@else')
      console.log('@ActivityServiceelse', source)
      data.sources = this.getSourceSystems();
    }

    if (this.fromTab == 'Members' && source) {
      this.applyFilterForSources(filter, data)
    }

    if (filter?.viewMode !== undefined && filter?.viewMode !== null) {
      data["viewMode"] = filter.viewMode;
    }
    if (filter?.groupType !== undefined && filter?.groupType !== null) {
      data["groupType"] = filter.groupType;
    }
    if (filter?.groupSystemId !== undefined && filter?.groupSystemId !== null) {
      data["groupSystemId"] = filter.groupSystemId;
    }
    if (filter?.groupObjectTypeId !== undefined && filter?.groupObjectTypeId !== null) {
      data["groupObjectTypeId"] = filter.groupObjectTypeId;
    }

    return this._http.post(url, data, {
      ...this._authService.ssOptions,
      responseType: 'blob' as 'json',
      observe: 'response' as 'body'
    });
  }

  getAllNestedActivities(
    keyword: string,
    pageSize: number,
    pageNumber: number,
    groupInfo?: any,
    filter?: any,
    sources?: any,
    parentActivityId?: any
  ): Observable<any> {
    const data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      ownerIds?: Array<any>;
      // OwnershipTypeIds?:Array<any>;
      followerIds?: Array<any>;
      // OpportunityIds?: Array<any>;
      // CustomerIds?: Array<any>;
      // SalesJobIds?: Array<any>;
      endDate?: any;
      activityStartDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isHealthy?: any;
      isManaged?: any;
      GroupInfo?: any;
      viewMode?: number;
      tags?: Array<any>;
      typeIds?: Array<any>;
      // includeBeforeDueDate?: boolean;
      sortBy?: number;
      managerIds?: Array<any>
      sources?: Array<any>
      parentActivityId?: any
    } = {
      groupType: 0,
      keyword: keyword,
      pageNumber: pageNumber,
      pageSize: pageSize,
      parentActivityId: parentActivityId
    };

    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    console.log('@filterData', filter)
    this.getDataProvider();

    if (!!filter.AssignedByUserIds) {
      data.managerIds = filter.AssignedByUserIds;
    } else {
      data.managerIds = [];
    }
    data.sortBy = 0;
    data.viewMode = filter?.ViewBy || ActivityViewByType.Activity;
    data.sources = this.getSourceSystems();
    this.applyFilterForSources(filter, data)
    data["endDate"] = null;
    data["startDate"] = null;
    data["includeUnlinkedActivities"] = true;

    var url = `activities-svc/api/activities/all`;

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllStatsForMembersDashboard(startDate: any, endDate: any = null, userId?: any): Observable<any> {

    this.getDataProvider();
    const url = `activities-svc/api/activities/all/stats`;
    let data = {};

    data["startDate"] = moment(startDate).locale('en').format('YYYY-MM-DD');
    data["endDate"] = moment(endDate).locale('en').format('YYYY-MM-DD');
    data["userId"] = userId;
    data["sources"] = this.getSourceSystems();
    // #46953 — always the complete population for the period. Group By Jobs /
    // PlanneXe must not exclude unlinked activities from these counts.
    data["includeUnlinkedActivities"] = true;

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllGroupsForMemberDashboard(
    keyword: string,
    groupType: number,
    filter?: any,
    userId?: any,
    sources?: any
  ): Observable<any> {
    var url = `activities-svc/api/activities/all/groups`;
    let data: {
      keyword: string;
      groupType: number;
      creatorIds?: Array<any>;
      endDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      TeamIds?: Array<any>;
      TacticIds?: Array<any>;
      OppProLogin?: any;
      viewMode: number
      pageNumber: number,
      pageSize: number
      includeUnlinkedActivities?: boolean,
    } = {
      groupType: groupType,
      viewMode: ActivityViewByType.Efforts,
      keyword: keyword,
      pageNumber: 1,
      pageSize: 100000
    };

    if (groupType == 7) {
      data.includeUnlinkedActivities = true;
    }
    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      }
      if (!!filter.EndDate) {
        data.endDate = moment(filter.EndDate).locale('en').format('YYYY-MM-DD');
      }
      if (!!filter.StartDate) {
        data.startDate = moment(filter.StartDate).locale('en').format('YYYY-MM-DD');
      }
      if (Array.isArray(filter.StatusIds) && filter.StatusIds.length) {
        data.statusIds = filter.StatusIds;
      }

      data["userId"] = userId;
      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
    }

    data["includeUnlinkedActivities"] = true;
    console.log('@groupByData', data)

    data["sources"] = sources || this.getSourceSystems();

    this.applyFilterForSources(filter, data);

    if (groupType == 6) {
      data.viewMode = ActivityViewByType.Efforts;
    }

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllGroupsForSystemFilter(
    groupSystemId: number,
    groupObjectTypeId: number,
    startDate: any,
    endDate: any,
    userId: any,
    keyword?: string
  ): Observable<any> {
    const url = `activities-svc/api/activities/all/groups`;
    const data: any = {
      groupType: 8,
      viewMode: 1,
      groupSystemId,
      groupObjectTypeId,
      pageNumber: 1,
      pageSize: 100000,
      includeUnlinkedActivities: false,
      statusIds: [6, 5, 2, 4, 10, 11],
      userId,
      sources: this.getSourceSystems(),
      isHealthy: null,
    };
    const searchKeyword = (keyword ?? '').toString().trim();
    if (searchKeyword) {
      data.keyword = searchKeyword;
    }
    if (startDate) data.startDate = moment(startDate).locale('en').format('YYYY-MM-DD');
    if (endDate) data.endDate = moment(endDate).locale('en').format('YYYY-MM-DD');
    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getAllDependentActivities(
    keyword: string,
    pageSize: number,
    pageNumber: number,
    dependencyActivityId?: any
  ): Observable<any> {
    const data: {
      keyword: string;
      pageNumber: number;
      pageSize: number;
      sources?: Array<any>
      dependencyActivityId?: any
    } = {
      keyword: keyword,
      pageNumber: pageNumber,
      pageSize: pageSize,
      dependencyActivityId: dependencyActivityId
    };
    this.getDataProvider();
    data.sources = this.getSourceSystems();
    data["includeUnlinkedActivities"] = true;

    var url = `activities-svc/api/activities/all/dependent`;

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }

  getUserStatsData(from: any, to: any): Observable<any> {
    let UserIdenediId = localStorage.getItem('idenedi.user.id');
    const url = `api/ConnecteXe/GetUserStats?UserIdenediId=${UserIdenediId}&From=${from}&To=${to}`;
    return this._http.get<any>(url, this._authService.ssOptions)
  }

  exportAllExcelCSV(
    keyword: string,
    groupType: number,
    pageSize: number,
    pageIndex: number,
    groupInfo?: any,
    filter?: any,
    dependencyActivityId?: number,
    userId?: number,
  ): Observable<any> {
    const data: {
      keyword: string;
      groupType: number;
      pageNumber: number;
      pageSize: number;
      creatorIds?: Array<any>;
      ownerIds?: Array<any>;
      // OwnershipTypeIds?:Array<any>;
      followerIds?: Array<any>;
      // OpportunityIds?: Array<any>;
      // CustomerIds?: Array<any>;
      // SalesJobIds?: Array<any>;
      endDate?: any;
      activityStartDate?: any;
      startDate?: any;
      statusIds?: Array<any>;
      isImportant?: any;
      isLagging?: any;
      isSigned?: any;
      isFollowed?: any;
      isHealthy?: any;
      isManaged?: any;
      userId?: any;
      GroupInfo?: any;
      viewMode?: number;

      tags?: Array<any>;
      typeIds?: Array<any>;
      sortBy?: number;
      managerIds?: Array<any>
      sources?: Array<any>;
      dependencyActivityId?: number;
    } = {
      groupType: groupType,
      keyword: keyword,
      pageNumber: pageIndex,
      pageSize: pageSize,
      dependencyActivityId: dependencyActivityId,
    };

    if (!!groupInfo) {
      data["groupKey"] = groupInfo.groupId;
      data.GroupInfo = {
        Id: groupInfo.groupId,
        StartDate: groupInfo.startDate,
        EndDate: groupInfo.endDate,
        Name: groupInfo.groupName,
        SubType: groupInfo.subType,
      };
    }

    console.log('@filterData', filter)
    this.getDataProvider();

    if (!!filter) {
      if (!!filter.CreatorIds) {
        data.creatorIds = filter.CreatorIds;
      } else {
        data.creatorIds = [];
      }
      if (!!filter.AssignedByUserIds) {
        data.managerIds = filter.AssignedByUserIds;
      } else {
        data.managerIds = [];
      }
      if (!!filter.AssignToIds) {
        data.ownerIds = filter.AssignToIds;
      } else {
        data.ownerIds = [];
      }
      if (!!filter.FollowedByIds) {
        data.followerIds = filter.FollowedByIds;
      } else {
        data.followerIds = [];
      }

      if (!!filter.DueDate) {
        data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
      }

      if (filter.IncludeOnOrBeforeDueDate != null && filter.IncludeOnOrBeforeDueDate != undefined && !!filter.DueDate) {
        if (!filter.IncludeOnOrBeforeDueDate) {
          data.startDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        } else {
          data.startDate = null;
          data.endDate = moment(filter.DueDate).locale('en').format('YYYY-MM-DD');
        }
      }

      if (!!filter.StatusIds) {
        data.statusIds = filter.StatusIds;
      }

      if (!!filter.StartDate) {
        data.startDate = moment(filter.StartDate).locale('en').format("YYYY-MM-DD");
      }

      if (!!filter.ActivityStartDate && filter.IncludeOnOrBeforeDueDate) {
        data.startDate = moment(filter.ActivityStartDate).locale('en').format("YYYY-MM-DD");
      }

      if (!!filter.ActivitySortBy) {
        data.sortBy = filter.ActivitySortBy;
      } else {
        data.sortBy = 0;
      }

      if (!!filter.EndDate) {
        data.endDate = moment(filter.EndDate).locale('en').format("YYYY-MM-DD");
      }

      if (this.forSprint) {
        data.isFollowed = false;
      }

      filter.IsImportant == true ? (data.isImportant = filter.IsImportant) : "";
      filter.IsLagging == true ? (data.isLagging = filter.IsLagging) : "";
      filter.IsSigned == true ? (data.isSigned = filter.IsSigned) : "";
      data.isFollowed = filter.IsFollowed;
      data.isManaged = filter.IsManaged;

      if (typeof filter.IsHealthy === 'boolean' && filter.IsHealthy === false)
        data.isHealthy = filter.IsHealthy;
      else data.isHealthy = null;

      if (!!filter.TagIds) {
        data.tags = filter.TagIds;
      } else {
        data.tags = [];
      }

      if (!!filter.Type && filter.Type.length == 1) {
        data.typeIds = filter.Type;
      } else {
        data.typeIds = [];
      }

    }

    data.viewMode = filter?.ViewBy || ActivityViewByType.Activity;
    if (groupType == 6) {
      data.viewMode = ActivityViewByType.Efforts;
    }
    // data["IsMine"] = this.SourceSystemId || this.TeamId ? false : true;
    // data["SourceSystemIds"] = this.getSourceSystemIds();
    data.sources = this.getSourceSystems();
    console.log('fromTab0', filter)
    if (userId) {
      data.userId = userId;
    }
    this.applyFilterForSources(filter, data)

    // if(this.fromTab == FromTab.Members || this.fromTab == FromTab.Listing || this.fromTab == FromTab.Actions || this.fromTab == FromTab.All){
    //   const filteredData = data["sources"].filter(item => item?.objects?.length !== 0);
    //   data.sources = filteredData;
    // }


    if (this.requirementId) {
      data["SourceObjectIdLevel2"] = parseInt(this.requirementId);
    }

    if (this.deliverableId) {
      data["SourceObjectIdLevel3"] = parseInt(this.deliverableId);
    }

    if (this.externalSystems.includes(this.fromTab)) {
      var url = `activities-svc/api/activities/all/export/csv`;
      if (data.dependencyActivityId || this.fromTab == FromTab.Members || this.fromTab == FromTab.Listing || this.fromTab == FromTab.Actions || this.fromTab == FromTab.All) {
        data["includeUnlinkedActivities"] = true;
      }
      else {
        data["includeUnlinkedActivities"] = false;
      }
    } else {
      data["includeUnlinkedActivities"] = true;
      var url = `activities-svc/api/activities/mine/export/csv`;
    }

    return this._http.post(url, data, {...this._authService.ssOptions,responseType: 'blob' as 'json',observe: 'response' as 'body'});
  }

    convertTechnadoptGuidId(objectIdString:any): Observable<any> {

    this.getDataProvider();
    const url = `activities-svc/api/activities/map-source-object-string-id`;
    let data = {};

    data['systemId'] =  DataProviderSourceSystem.Technadopt,
    data['objectIdString'] = objectIdString;

    return this._http.post<any>(url, data, this._authService.ssOptions);
  }
}
